import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LoggedInCallback} from "../../service-auth/cognito.service";
import {Router} from "@angular/router";
import {RoleChangeListener, StartupService} from "../../service-ui/startup.service";
import { MatSidenav } from "@angular/material/sidenav";
import {MediaMatcher} from "@angular/cdk/layout";
import {PrintNodeOrderItem} from "../../../model/PrintNodeOrderItem";
import {PrintNodeOrderItemService} from "../../service-data/print-node-order-item.service";
import {ManufacturingSetsComponent} from "../manufacturing-sets/manufacturing-sets.component";
import {ManufacturingTaskBucket} from "../../../model/ManufacturingTaskBucket";
import {LanguagePipe} from "../../pipe/language.pipe";
import {ManufacturingTaskBucketService} from "../../service-data/manufacturing-task-bucket.service";
import {ManufacturingTaskBucketPeriod} from "../../../model/ManufacturingTaskBucketPeriod";
import {ManufacturingSetService} from "../../service-data/manufacturing-set.service";
import {ManufacturingSet} from "../../../model/ManufacturingSet";
import {ManufacturingTask} from "../../../model/ManufacturingTask";
import {ManufacturingTaskService} from "../../service-data/manufacturing-task.service";
import {ManufacturingTaskBucketPeriodService} from "../../service-data/manufacturing-task-bucket-period.service";
import {AssignPrintNodeOrderItemToManufacturingSet} from "./assignPrintNodeOrderItemToManufacturingSet";
import {SetPlanningGroup} from "./SetPlanningGroup";
import {PrintNodeOrder} from "../../../model/PrintNodeOrder";
import {PrintNodeOrderService} from "../../service-data/print-node-order.service";
import {ManufacturingSetAssignerService} from "../../service-data/manufacturing-set-assigner.service";
import {FacilityInventoryProduct} from "../../../model/FacilityInventoryProduct";
import {FacilityInventoryProductService} from "../../service-data/facility-inventory-product.service";
import {Subject} from "rxjs";
import {DataObject} from "../../../model/DataObject";
import {takeUntil} from "rxjs/operators";
import { MatDialog } from '@angular/material/dialog';
import { ReplenishmentSelectorComponent } from './replenishment-selector/replenishment-selector.component';
import {Order} from "../../../model/Order";
import {OrderDeliverTo} from "../../../model/OrderDeliverTo";
import {OrderItem} from "../../../model/OrderItem";
import {FacilityService} from "../../service-data/facility.service";
import {OrderService} from "../../service-data/order.service";
import {OrderDeliverToService} from "../../service-data/order-deliver-to.service";
import {ServerErrorToastService} from "../../service-ui/server-error-toast.service";
import {serverErrorCode} from "../../service-data/http-error";
import {ConfirmDialogComponent} from "../confirm-dialog/confirm-dialog.component";
import {NotificationsService} from "../../service-data/notifications.service";

@Component({
  selector: 'app-manufacturing-buckets',
  templateUrl: './manufacturing-buckets.component.html',
  styleUrls: ['./manufacturing-buckets.component.css']
})

export class ManufacturingBucketsComponent implements OnDestroy, OnInit, LoggedInCallback, AfterViewInit, RoleChangeListener, AssignPrintNodeOrderItemToManufacturingSet {
  public static types = ['interior', 'binding', 'lamination', 'impositionLayout', 'trimSize', 'paperType', 'oneDigitZip'];

  localizeNumber(value: any): string {
    return LanguagePipe.localizeNumber(value);
  }

  // Track processing state for each ManufacturingSet by ID
  isProcessingReplenishment: { [setId: number]: boolean } = {};

  @ViewChild('mainSideNav', {static: true}) mainSideNav: MatSidenav;

  assignPrintNodeOrderItemToManufacturingSet: AssignPrintNodeOrderItemToManufacturingSet = this;

  manufacturingTaskBuckets: ManufacturingTaskBucket[];
  actionableManufacturingTaskBuckets: any[];

  // Display flags and filters
  showEmptyTaskBuckets: boolean = false;
  showClosedTaskBuckets: boolean = false;
  showClosedSets: boolean = false;
  showLockedTaskBuckets: boolean = true;
  showOpenTaskBuckets: boolean = true;
  showOnlyPinned: boolean = false;
  showPrintNodeOrderItems: boolean = true;
  showDates: boolean = true;
  showStats: boolean = true;
  showEmptySets: boolean = false;

  lastTimeStatsComputed;

  expandSets: any = {};
  expandBucketPeriods: any = {};
  expandBucketPeriodSets: any = {};
  expandBuckets: any = {};

  dataIndex = 0; // 0 for Quantity, 1 for feetOrSheets, 2 for number of line items

  facilityInventoryProducts: FacilityInventoryProduct[] = [];

  Math = Math;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  onDestroySubject: Subject<boolean> = new Subject();

  setPlanningGroups: SetPlanningGroup[] = [];
  selectedPrintNodeOrderId: number = 0;

  static getRevenue(printNodeOrderItem: PrintNodeOrderItem): number {
    const perBookMinimumTotal = 2.75;
    const perBook = 1.5;
    const perBookMatteLamination = 0.11;
    const perBookGlossLamination = 0;
    const perPage = 0.0125;
    const perPageColor = 0;
    const pageMultiplier = ((printNodeOrderItem.book.body.width / 72 > 6 || printNodeOrderItem.book.body.height / 72 > 9) ? 2 : 1 );
    const laminationAddOn = (printNodeOrderItem.book.cover.laminateType === 'MATTE' ? perBookMatteLamination : perBookGlossLamination );
    switch (printNodeOrderItem.book.body.paperType_ID) {
      case 1: {
        return Math.max(perBookMinimumTotal, perBook + printNodeOrderItem.book.body.numPages * pageMultiplier * perPage ) + laminationAddOn;
      }
      case 2: {
        return Math.max(perBookMinimumTotal, perBook + printNodeOrderItem.book.body.numPages * pageMultiplier * perPage ) + laminationAddOn;
      }
      case 4: {
        return Math.max(perBookMinimumTotal, perBook + printNodeOrderItem.book.body.numPages * pageMultiplier * perPage ) + laminationAddOn;
      }
      case 5: {
        return Math.max(perBookMinimumTotal, perBook + printNodeOrderItem.book.body.numPages * pageMultiplier * perPageColor ) + laminationAddOn;
      }
      case 6: {
        return Math.max(perBookMinimumTotal, perBook + printNodeOrderItem.book.body.numPages * pageMultiplier * perPageColor ) + laminationAddOn;
      }
      case 7: {
        return Math.max(perBookMinimumTotal, perBook + printNodeOrderItem.book.body.numPages * pageMultiplier * perPageColor ) + laminationAddOn;
      }
      case 8: {
        return Math.max(perBookMinimumTotal, perBook + printNodeOrderItem.book.body.numPages * pageMultiplier * perPageColor ) + laminationAddOn;
      }
    }
  }

  static getManufacturingCost(facilityId: number, printNodeOrderItem: PrintNodeOrderItem): number {
    switch (facilityId) {
      case 1: {
        return 1.00 + Math.max(1, printNodeOrderItem.book.body.numPages * ((printNodeOrderItem.book.body.width / 72 > 6 || printNodeOrderItem.book.body.height / 72 > 9) ? 2 : 1 ) * 0.011 );
        break;
      }
      case 7: {
        const heavySheetRate = 0.072;
        const lightSheetRate = 0.064;
        const cremeSheetRate = 0.092;
        // const bookRate500AndUnder = 0.8;
        const bookRate500Plus = 0.7;
        const color60UncoatedTextSheetRate = 0.19;
        const color800MatteTextSheetRate = 0.21;
        const color800GlossTextSheetRate = 0.21;
        const color100GlossTextSheetRate = 0.23;

        let rate = 0;
        let count = 0;
        try {
          if ( printNodeOrderItem['sheets'] ) {
            printNodeOrderItem['sheets'].forEach( singleBook => {
              switch (printNodeOrderItem.book.body.paperType_ID) {
                case 1: {
                  rate += bookRate500Plus + singleBook * heavySheetRate;
                  count++;
                  break;
                }
                case 2: {
                  rate += bookRate500Plus + singleBook * lightSheetRate;
                  count++;
                  break;
                }
                case 4: {
                  rate += bookRate500Plus + singleBook * cremeSheetRate;
                  count++;
                  break;
                }
                case 5: {
                  rate += bookRate500Plus + singleBook * color60UncoatedTextSheetRate;
                  count++;
                  break;
                }
                case 6: {
                  rate += bookRate500Plus + singleBook * color800MatteTextSheetRate;
                  count++;
                  break;
                }
                case 7: {
                  rate += bookRate500Plus + singleBook * color800GlossTextSheetRate;
                  count++;
                  break;
                }
                case 8: {
                  rate += bookRate500Plus + singleBook * color100GlossTextSheetRate;
                  count++;
                  break;
                }
              }
            });
          }
        } catch (e) {
          console.log(`Error computing getManufacturingCost for printNode 7 ${e.message}`);
        }

        return count > 0 ? rate / count : 0;
      }
    }
  }

  public static getFacilityBasedOnCountryStateAndOneDigitZip(country: string, state: string, oneDigitZip: string, facilityId: number): string {
    let facility = '';
    if ( country === 'US' || country === 'USA' ) {
      switch (oneDigitZip) {
        case '0': {
          facility = '7';
          break;
        }
        case '1': {
          facility = '7';
          break;
        }
        case '2': {
          facility = '7';
          break;
        }
        case '3': {
          facility = '7';
          break;
        }
        case '4': {
          facility = '7';
          break;
        }
        case '5': {
          facility = '7';
          break;
        }
        case '6': {
          facility = '7';
          break;
        }
        case '7': {
          facility = '7';
          break;
        }
        case '8': {
          switch (state) {
            case 'AZ': {
              facility = '1';
              break;
            }
            case 'CO': {
              facility = '1';
              break;
            }
            case 'ID': {
              facility = '1';
              break;
            }
            case 'NM': {
              facility = '1';
              break;
            }
            case 'TX': {
              facility = '7';
              break;
            }
            case 'UT': {
              facility = '1';
              break;
            }
            case 'WY': {
              facility = '1';
              break;
            }
            default: {
              facility = '2';
              break;
            }
          }
          break;
        }
        case '9': {
          facility = '1';
          break;
        }
        default : {
          facility = '2';
          break;
        }
      }
    } else {
      facility = '2';
    }
    if ('' + facilityId === facility ) {
      return '0';
    } else {
      if ( oneDigitZip === '2' ) {
        return '2';
      } else {
        return 'X';
      }
    }
  }

  // ---------------------------------------------------------------------------
  // inventoryType consistency helpers
  //
  // A PrintNodeOrder carries an order-level `inventoryType`; when that value is
  // MIXED each PrintNodeOrderItem carries its own. A ManufacturingSet records
  // the inventoryType it was built for in `details.inventoryType`, and a
  // ManufacturingTaskBucket / ManufacturingTaskBucketPeriod is implicitly for
  // one inventoryType or the other. Nothing enforces that those agree, so an
  // item can end up sitting in a set (or a set inside a period) that is meant
  // for the other fulfilment path. These helpers derive the "effective"
  // inventoryType at each level so the UI can flag the disagreement.
  //
  // Every helper returns '' for "unknown", and callers must treat '' as "no
  // opinion, do not flag" — flagging on unknown would light up the whole board.
  // ---------------------------------------------------------------------------

  /** The only two inventoryType values that are meaningful on a PrintNodeOrderItem. */
  public static readonly ITEM_INVENTORY_TYPES = ['FULFILL_FROM_INVENTORY', 'PRINT_TO_ORDER'];

  /**
   * Collapse any order-level inventoryType onto the item-level vocabulary.
   * REPLENISH_INVENTORY orders are manufactured exactly like PRINT_TO_ORDER
   * ones (the books are printed, they just land in inventory instead of
   * shipping), which is the same mapping
   * `PrintNodeOrderItemInManufacturingBucketComponent.getCurrentInventoryType`
   * has always applied. MIXED is deliberately NOT collapsed — it means
   * "look at the item".
   */
  public static normalizeInventoryType(inventoryType: string): string {
    if ( inventoryType === 'REPLENISH_INVENTORY' ) {
      return 'PRINT_TO_ORDER';
    }
    return inventoryType ? inventoryType : '';
  }

  /** True when `inventoryType` is one of the two values an item may legitimately hold. */
  public static isItemInventoryTypeValid(inventoryType: string): boolean {
    return ManufacturingBucketsComponent.ITEM_INVENTORY_TYPES.indexOf(inventoryType) > -1;
  }

  /**
   * The inventoryType this PrintNodeOrderItem is actually going to be
   * manufactured under: its own value when the order is MIXED, otherwise the
   * order's value normalized onto the item vocabulary.
   */
  public static getEffectiveInventoryType(printNodeOrderItem: PrintNodeOrderItem): string {
    if ( !printNodeOrderItem || !printNodeOrderItem.printNodeOrder ) {
      return '';
    }
    if ( printNodeOrderItem.printNodeOrder.inventoryType === 'MIXED' ) {
      return ManufacturingBucketsComponent.normalizeInventoryType(printNodeOrderItem.inventoryType);
    }
    return ManufacturingBucketsComponent.normalizeInventoryType(printNodeOrderItem.printNodeOrder.inventoryType);
  }

  /** The inventoryType a ManufacturingSet was built for, or '' when it does not say. */
  public static getManufacturingSetInventoryType(manufacturingSet: ManufacturingSet): string {
    if ( !manufacturingSet || !manufacturingSet.details ) {
      return '';
    }
    return ManufacturingBucketsComponent.normalizeInventoryType(manufacturingSet.details.inventoryType);
  }

  /**
   * The inventoryType a ManufacturingTaskBucket is for.
   *
   * There is no `inventoryType` column on ManufacturingTaskBucket yet, so this
   * keeps the long-standing name heuristic (see the TODO in
   * `PrintNodeOrderItemInManufacturingBucketComponent.isInventoryTypeChangeNeeded`)
   * while preferring a real `details.inventoryType` if one ever appears.
   * 'Replenish' is excluded explicitly: a replenishment bucket contains the
   * word "Inventory" but is printed, not picked.
   */
  public static getManufacturingTaskBucketInventoryType(manufacturingTaskBucket: any): string {
    if ( !manufacturingTaskBucket ) {
      return '';
    }
    if ( manufacturingTaskBucket.details && manufacturingTaskBucket.details.inventoryType ) {
      return ManufacturingBucketsComponent.normalizeInventoryType(manufacturingTaskBucket.details.inventoryType);
    }
    if ( manufacturingTaskBucket.inventoryType ) {
      return ManufacturingBucketsComponent.normalizeInventoryType(manufacturingTaskBucket.inventoryType);
    }
    const name = manufacturingTaskBucket.name ? String(manufacturingTaskBucket.name) : '';
    if ( name.indexOf('Replenish') > -1 ) {
      return 'PRINT_TO_ORDER';
    }
    if ( name.indexOf('Inventory') > -1 || name.indexOf('Fulfill') > -1 || name.indexOf('Fulfil') > -1 ) {
      return 'FULFILL_FROM_INVENTORY';
    }
    return '';
  }

  /**
   * The inventoryType a ManufacturingTaskBucketPeriod is for: its bucket's
   * value when the bucket declares one, otherwise the value shared by a strict
   * majority of the sets it contains. A tie (or an empty period) yields '' so
   * nothing is flagged — with no majority there is no "odd set out" to point at.
   */
  public static getManufacturingTaskBucketPeriodInventoryType(manufacturingTaskBucketPeriod: ManufacturingTaskBucketPeriod, manufacturingTaskBucket?: any): string {
    if ( !manufacturingTaskBucketPeriod ) {
      return '';
    }
    const bucketInventoryType = ManufacturingBucketsComponent.getManufacturingTaskBucketInventoryType(manufacturingTaskBucket ? manufacturingTaskBucket : manufacturingTaskBucketPeriod.manufacturingTaskBucket);
    if ( bucketInventoryType ) {
      return bucketInventoryType;
    }
    const counts = {};
    for ( const manufacturingSet of ( manufacturingTaskBucketPeriod.manufacturingSets ? manufacturingTaskBucketPeriod.manufacturingSets : [] ) ) {
      const setInventoryType = ManufacturingBucketsComponent.getManufacturingSetInventoryType(manufacturingSet);
      if ( setInventoryType ) {
        counts[setInventoryType] = ( counts[setInventoryType] ? counts[setInventoryType] : 0 ) + 1;
      }
    }
    let winner = '';
    let winningCount = 0;
    let tied = false;
    for ( const key of Object.keys(counts) ) {
      if ( counts[key] > winningCount ) {
        winner = key;
        winningCount = counts[key];
        tied = false;
      } else {
        if ( counts[key] === winningCount ) {
          tied = true;
        }
      }
    }
    return tied ? '' : winner;
  }

  /**
   * True when `printNodeOrderItem`'s effective inventoryType disagrees with the
   * ManufacturingSet it sits in or with the ManufacturingTaskBucket that set
   * belongs to. An item with no usable inventoryType at all is NOT reported
   * here — that is the separate "invalid" (orange) condition.
   */
  public static isPrintNodeOrderItemInventoryTypeMismatched(printNodeOrderItem: PrintNodeOrderItem, manufacturingSet: ManufacturingSet, manufacturingTaskBucket?: any): boolean {
    const itemInventoryType = ManufacturingBucketsComponent.getEffectiveInventoryType(printNodeOrderItem);
    if ( !ManufacturingBucketsComponent.isItemInventoryTypeValid(itemInventoryType) ) {
      return false;
    }
    const setInventoryType = ManufacturingBucketsComponent.getManufacturingSetInventoryType(manufacturingSet);
    if ( setInventoryType && setInventoryType !== itemInventoryType ) {
      return true;
    }
    const bucketInventoryType = ManufacturingBucketsComponent.getManufacturingTaskBucketInventoryType(manufacturingTaskBucket);
    if ( bucketInventoryType && bucketInventoryType !== itemInventoryType ) {
      return true;
    }
    return false;
  }

  /** Count of items in `manufacturingSet` whose inventoryType disagrees with the set. */
  getManufacturingSetInventoryTypeMismatchCount(manufacturingSet: ManufacturingSet, manufacturingTaskBucket?: any): number {
    if ( !manufacturingSet || !manufacturingSet.printNodeOrderItems ) {
      return 0;
    }
    let count = 0;
    for ( const printNodeOrderItem of manufacturingSet.printNodeOrderItems ) {
      if ( ManufacturingBucketsComponent.isPrintNodeOrderItemInventoryTypeMismatched(printNodeOrderItem, manufacturingSet, manufacturingTaskBucket) ) {
        count++;
      }
    }
    return count;
  }

  /** Count of items in `manufacturingSet` with no usable inventoryType of their own. */
  getManufacturingSetInventoryTypeUnsetCount(manufacturingSet: ManufacturingSet): number {
    if ( !manufacturingSet || !manufacturingSet.printNodeOrderItems ) {
      return 0;
    }
    let count = 0;
    for ( const printNodeOrderItem of manufacturingSet.printNodeOrderItems ) {
      if ( !ManufacturingBucketsComponent.isItemInventoryTypeValid(ManufacturingBucketsComponent.getEffectiveInventoryType(printNodeOrderItem)) ) {
        count++;
      }
    }
    return count;
  }

  /**
   * True when the set's own inventoryType disagrees with the
   * ManufacturingTaskBucketPeriod it has been placed in.
   */
  isManufacturingSetInventoryTypeMismatchedWithPeriod(manufacturingSet: ManufacturingSet, manufacturingTaskBucketPeriod: ManufacturingTaskBucketPeriod, manufacturingTaskBucket?: any): boolean {
    const setInventoryType = ManufacturingBucketsComponent.getManufacturingSetInventoryType(manufacturingSet);
    if ( !setInventoryType ) {
      return false;
    }
    const periodInventoryType = ManufacturingBucketsComponent.getManufacturingTaskBucketPeriodInventoryType(manufacturingTaskBucketPeriod, manufacturingTaskBucket);
    if ( !periodInventoryType ) {
      return false;
    }
    return setInventoryType !== periodInventoryType;
  }

  /** Human-readable label for an inventoryType, for tooltips.
   *
   * The inventoryType values themselves are enum tokens and are NOT translation
   * ids — the bundles carry the Title Case display forms ('Fulfill From
   * Inventory', 'Print To Order', ...), so map before looking up or every
   * tooltip renders the raw token. */
  public static readonly INVENTORY_TYPE_LABELS = {
    MIXED: 'Mixed',
    FULFILL_FROM_INVENTORY: 'Fulfill From Inventory',
    PRINT_TO_ORDER: 'Print To Order',
    REPLENISH_INVENTORY: 'Replenish Inventory'
  };

  getInventoryTypeLabel(inventoryType: string): string {
    const label = ManufacturingBucketsComponent.INVENTORY_TYPE_LABELS[inventoryType];
    return LanguagePipe.get(label ? label : 'Not Set');
  }

  /** Tooltip for the red "items disagree with this set" indicator. */
  getManufacturingSetItemMismatchTitle(manufacturingSet: ManufacturingSet, manufacturingTaskBucket?: any): string {
    const count = this.getManufacturingSetInventoryTypeMismatchCount(manufacturingSet, manufacturingTaskBucket);
    return LanguagePipe.get('Items With A Different Inventory Type Than This Set') + ': ' + LanguagePipe.localizeNumber(count)
      + ' (' + this.getInventoryTypeLabel(ManufacturingBucketsComponent.getManufacturingSetInventoryType(manufacturingSet)) + ')';
  }

  /** Tooltip for the amber "this set disagrees with its period" indicator. */
  getManufacturingSetPeriodMismatchTitle(manufacturingSet: ManufacturingSet, manufacturingTaskBucketPeriod: ManufacturingTaskBucketPeriod, manufacturingTaskBucket?: any): string {
    return LanguagePipe.get('Set Inventory Type Does Not Match Its Bucket Period')
      + ': ' + this.getInventoryTypeLabel(ManufacturingBucketsComponent.getManufacturingSetInventoryType(manufacturingSet))
      + ' / ' + this.getInventoryTypeLabel(ManufacturingBucketsComponent.getManufacturingTaskBucketPeriodInventoryType(manufacturingTaskBucketPeriod, manufacturingTaskBucket));
  }

  constructor(public router: Router,
              public startupService: StartupService,
              private manufacturingTaskBucketPeriodService: ManufacturingTaskBucketPeriodService,
              private manufacturingTaskService: ManufacturingTaskService,
              private manufacturingSetService: ManufacturingSetService,
              private manufacturingTaskBucketService: ManufacturingTaskBucketService,
              private orderService: OrderService,
              private orderDeliverToService: OrderDeliverToService,
              private printNodeOrderItemService: PrintNodeOrderItemService,
              private printNodeOrderService: PrintNodeOrderService,
              private facilityService: FacilityService,
              private manufacturingSetAssignerService: ManufacturingSetAssignerService,
              private facilityInventoryProductService: FacilityInventoryProductService,
              private serverErrorToastService: ServerErrorToastService,
              public changeDetectorRef: ChangeDetectorRef,
              public media: MediaMatcher,
              public dialog: MatDialog) {
    this.startupService.addRoleChangeListener(this);
    this.startupService.touchLastUserActivity();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  roleChanged(role: string, roleId: string): void {
    this.getData();
  }


  ngOnInit() {
    this.startupService.isAuthenticated(this);
  }

  ngAfterViewInit(): void {
  }

  isLoggedIn(message: string, isLoggedIn: boolean) {
    if (!isLoggedIn) {
      this.router.navigate(['/home/login']);
    } else {
      this.getData();
    }
  }

  addUpdateManufacturingTaskBucket(o: ManufacturingTaskBucket) {
    try {
      if (this.matchManufacturingTaskBucket(o)) {
        // console.log(`Match in ManufacturingBucketsComponent addUpdateManufacturingTaskBucket ${o.getId()} ${this.manufacturingTaskBuckets} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);

        if (!this.contains(o, this.manufacturingTaskBuckets)) {
          this.manufacturingTaskBuckets.push(o);
        }
      } else {
        if (this.contains(o, this.manufacturingTaskBuckets)) {
          const foundIndex = this.manufacturingTaskBuckets.findIndex(item => item.getId() === o.getId());
          if (foundIndex > -1) {
            this.manufacturingTaskBuckets.splice(foundIndex, 1);
          }
        }
      }
      this.computeActionalbeManufacturingTaskBucket(o);
    } catch (e) {
      console.log(`ERROR in ManufacturingBucketsComponent addUpdateManufacturingTaskBucket ${o.getId()} ${e.message} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);
    }
  }

  deleteManufacturingTaskBucket(o: ManufacturingTaskBucket) {
    try {
      if (this.contains(o, this.manufacturingTaskBuckets)) {
        const foundIndex = this.manufacturingTaskBuckets.findIndex(item => item.getId() === o.getId());
        if (foundIndex > -1) {
          this.manufacturingTaskBuckets.splice(foundIndex, 1);
        }
      }
      this.computeActionalbeManufacturingTaskBucket(o);
    } catch (e) {
      console.log(`ERROR in ManufacturingBucketsComponent deleteManufacturingTaskBucket ${o.getId()} ${e.message} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);
    }
  }

  matchManufacturingTaskBucket(o: ManufacturingTaskBucket): boolean {
    if (o) {
      return true;
    }
    return false;
  }

  addUpdateManufacturingTaskBucketPeriod(o: ManufacturingTaskBucketPeriod) {
    try {
      if (this.matchManufacturingTaskBucketPeriod(o)) {
        this.computeActionalbeManufacturingTaskBucket(o.manufacturingTaskBucket);
      }
    } catch (e) {
      console.log(`ERROR in ManufacturingBucketsComponent addUpdateManufacturingTaskBucket ${o.getId()} ${e.message} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);
    }
  }

  deleteManufacturingTaskBucketPeriod(o: ManufacturingTaskBucketPeriod) {
    try {
      this.computeActionalbeManufacturingTaskBucket(o.manufacturingTaskBucket);
    } catch (e) {
      console.log(`ERROR in ManufacturingBucketsComponent deleteManufacturingTaskBucketPeriod ${o.getId()} ${e.message} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);
    }
  }

  matchManufacturingTaskBucketPeriod(o: ManufacturingTaskBucketPeriod): boolean {
    if (o) {
      return true;
    }
    return false;
  }

  addUpdateManufacturingSet(o: ManufacturingSet) {
    try {
      if (this.matchManufacturingSet(o)) {
        this.computeActionalbeManufacturingTaskBucket(o.manufacturingTaskBucketPeriod.manufacturingTaskBucket);
      }
    } catch (e) {
      console.log(`ERROR in ManufacturingBucketsComponent addUpdateManufacturingSet ${o.getId()} ${e.message} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);
    }
  }

  deleteManufacturingSet(o: ManufacturingSet) {
    try {
      this.computeActionalbeManufacturingTaskBucket(o.manufacturingTaskBucketPeriod.manufacturingTaskBucket);
    } catch (e) {
      console.log(`ERROR in ManufacturingBucketsComponent deleteManufacturingSet ${o.getId()} ${e.message} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);
    }
  }

  matchManufacturingSet(o: ManufacturingSet): boolean {
    if (o) {
      return true;
    }
    return false;
  }

  /**
   * Remembers which ManufacturingTaskBucket each PrintNodeOrderItem was last
   * seen under.
   *
   * When an item moves between ManufacturingSets that belong to DIFFERENT
   * buckets, the update notification only says where the item is now.
   * Recomputing just that bucket refreshes the destination while leaving the
   * source bucket's projection holding pre-move totals, so the counts on the
   * bucket it left never come down. Keeping the previous bucket id lets us
   * recompute both ends of the move.
   */
  private lastKnownBucketIdByPrintNodeOrderItemId: { [printNodeOrderItemId: number]: number } = {};

  /** Recompute the bucket an item has just left, if we know which one it was. */
  private recomputePreviousBucketForPrintNodeOrderItem(printNodeOrderItemId: number, currentBucketId: number) {
    const previousBucketId = this.lastKnownBucketIdByPrintNodeOrderItemId[printNodeOrderItemId];
    if ( previousBucketId && previousBucketId !== currentBucketId ) {
      const previousBucket = this.manufacturingTaskBucketService.objectsById['' + previousBucketId];
      if ( previousBucket ) {
        this.computeActionalbeManufacturingTaskBucket(previousBucket);
      }
    }
  }

  addUpdatePrintNodeOrderItem(o: PrintNodeOrderItem) {
    try {
      if (this.matchPrintNodeOrderItem(o)) {
        if ( o.manufacturingSet && o.manufacturingSet.manufacturingTaskBucketPeriod && o.manufacturingSet.manufacturingTaskBucketPeriod.manufacturingTaskBucket ) {
          const bucket = o.manufacturingSet.manufacturingTaskBucketPeriod.manufacturingTaskBucket;
          this.recomputePreviousBucketForPrintNodeOrderItem(o.getId(), bucket.ID);
          this.lastKnownBucketIdByPrintNodeOrderItemId[o.getId()] = bucket.ID;
          this.computeActionalbeManufacturingTaskBucket(bucket);
        } else {
          // The item no longer resolves to a bucket - it was unassigned, or
          // its set/period/bucket chain has not linked up yet. Either way the
          // bucket it used to be in still shows it and has to be recomputed.
          this.recomputePreviousBucketForPrintNodeOrderItem(o.getId(), 0);
          delete this.lastKnownBucketIdByPrintNodeOrderItemId[o.getId()];
          if ( !o.manufacturingSet  ) {
            // console.log(`In ManufacturingTaskBuckets.addUpdatePrintNodeOrderItem the PrintNodeOrderItem does not have a ManufacturingSet`);
          } else {
            if ( !o.manufacturingSet.manufacturingTaskBucketPeriod  ) {
              console.log(`In ManufacturingTaskBuckets.addUpdatePrintNodeOrderItem the PrintNodeOrderItem does not have a ManufacturingSet that has a ManufacturingTaskBucketPeriod`);
            } else {
              if ( !o.manufacturingSet.manufacturingTaskBucketPeriod.manufacturingTaskBucket  ) {
                console.log(`In ManufacturingTaskBuckets.addUpdatePrintNodeOrderItem the PrintNodeOrderItem does not have a ManufacturingSet that has a ManufacturingTaskBucketPeriod that has a ManufacturingTaskBucket`);
              }
            }
          }
        }
      }
    } catch (e) {
      console.log(`ERROR in ManufacturingBucketsComponent addUpdatePrintNodeOrderItem ${o.getId()} ${e.message} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);
    }
  }

  deletePrintNodeOrderItem(o: PrintNodeOrderItem) {
    try {
      this.computeActionalbeManufacturingTaskBucket(o.manufacturingSet.manufacturingTaskBucketPeriod.manufacturingTaskBucket);
    } catch (e) {
      console.log(`ERROR in ManufacturingBucketsComponent deletePrintNodeOrderItem ${o.getId()} ${e.message} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);
    }
  }

  matchPrintNodeOrderItem(o: PrintNodeOrderItem): boolean {
    if (o) {
      return true;
    }
    return false;
  }

  addUpdateFacilityInventoryProduct(o: FacilityInventoryProduct) {
    try {
      if (this.matchFacilityInventoryProduct(o)) {
        // console.log(`Match in ManufacturingBucketsComponent addUpdateFacilityInventoryProduct ${o.getId()} ${this.manufacturingTaskBuckets} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);

        // Was `this.contains(o, this.manufacturingTaskBuckets)` - the
        // wrong array, which can never contain a FacilityInventoryProduct,
        // so this test was always true and every add AND every update
        // appended another copy. The duplicates were invisible until
        // something downstream rendered per FIP, at which point one
        // inventory item showed up as N identical rows.
        if (!this.contains(o, this.facilityInventoryProducts)) {
          this.facilityInventoryProducts.push(o);
        }
      } else {
        if (this.contains(o, this.facilityInventoryProducts)) {
          const foundIndex = this.facilityInventoryProducts.findIndex(item => item.getId() === o.getId());
          if (foundIndex > -1) {
            this.facilityInventoryProducts.splice(foundIndex, 1);
          }
        }
      }
      // this.computeActionalbeManufacturingTaskBuckets(); Not sure this is a problem removing
    } catch (e) {
      console.log(`ERROR in ManufacturingBucketsComponent addUpdateFacilityInventoryProduct ${o.getId()} ${e.message} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);
    }
  }

  deleteFacilityInventoryProduct(o: FacilityInventoryProduct) {
    try {
      if (this.contains(o, this.facilityInventoryProducts)) {
        const foundIndex = this.facilityInventoryProducts.findIndex(item => item.getId() === o.getId());
        if (foundIndex > -1) {
          this.facilityInventoryProducts.splice(foundIndex, 1);
        }
      }
      // this.computeActionalbeManufacturingTaskBuckets(); Not sure this is a problem removing
    } catch (e) {
      console.log(`ERROR in ManufacturingBucketsComponent deleteFacilityInventoryProduct ${o.getId()} ${e.message} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);
    }
  }

  matchFacilityInventoryProduct(o: FacilityInventoryProduct): boolean {
    if (o) {
      return true;
    }
    return false;
  }

  contains(object: DataObject, array: DataObject[]): boolean {
    for (const o of array) {
      if (o.getId() === object.getId()) {
        return true;
      }
    }
    return false;
  }
  computeActionableManufacturingTaskBuckets() {
    for (const manufacturingTaskBucket of this.manufacturingTaskBuckets) {
      this.computeActionalbeManufacturingTaskBucket(manufacturingTaskBucket);
    }
  }

  addActionableManufacturingTaskBucket(actionableManufacturingTaskBucket: any) {
    // this.actionableManufacturingTaskBuckets = [];
    if ( !this.actionableManufacturingTaskBuckets ) {
      this.actionableManufacturingTaskBuckets = [];
    }
    let found = false;
    for ( let i = 0; i < this.actionableManufacturingTaskBuckets.length; i++) {
      if ( this.actionableManufacturingTaskBuckets[i]['ID'] === actionableManufacturingTaskBucket['ID'] ) {
        this.actionableManufacturingTaskBuckets[i] = actionableManufacturingTaskBucket;
        found = true;
      }
    }
    if ( !found ) {
      this.actionableManufacturingTaskBuckets.push(actionableManufacturingTaskBucket);
    }
  }
  // Note: This is primative and recomputes everything with ANY change
  computeActionalbeManufacturingTaskBucket(manufacturingTaskBucket: ManufacturingTaskBucket) {
    // if ( this.lastTimeStatsComputed &&  (new Date().getTime() - this.lastTimeStatsComputed.getTime()) < 5000) {
    //   console.log(`In computeActionalbeManufacturingTaskBuckets returing without computing ${this.lastTimeStatsComputed.toString()}`);
    //   return;
    // }
    // console.log(`In computeActionalbeManufacturingTaskBuckets                  COMPUTING ${this.lastTimeStatsComputed ? this.lastTimeStatsComputed.toString() : 'Not set yet' }`);
    // this.lastTimeStatsComputed = new Date();

    // this.actionableManufacturingTaskBuckets = [];
    // for (const manufacturingTaskBucket of this.manufacturingTaskBuckets) {
      const actionableManufacturingTaskBucket = {};
      actionableManufacturingTaskBucket['ID'] = manufacturingTaskBucket.ID;
      actionableManufacturingTaskBucket['name'] = manufacturingTaskBucket.name;
      actionableManufacturingTaskBucket['printnode_ID'] = manufacturingTaskBucket.printnode_ID;
      actionableManufacturingTaskBucket['manufacturingProcess_id'] = manufacturingTaskBucket.manufacturingProcess_id;
      actionableManufacturingTaskBucket['SinglesOrBatch'] = manufacturingTaskBucket.name.indexOf('Single') !== -1 ? 'SINGLES' : 'BATCH';
      actionableManufacturingTaskBucket['manufacturingTaskBucketPeriods'] = [];
      for (const manufacturingTaskBucketPeriod of manufacturingTaskBucket.manufacturingTaskBucketPeriods) {
        const actionableMacturingTaskBucketPeriod = {};
        actionableMacturingTaskBucketPeriod['ID'] = manufacturingTaskBucketPeriod.ID;
        actionableMacturingTaskBucketPeriod['period'] = manufacturingTaskBucketPeriod.period;
        actionableMacturingTaskBucketPeriod['SinglesOrBatch'] = actionableManufacturingTaskBucket['SinglesOrBatch'];
        actionableMacturingTaskBucketPeriod['manufacturingSets'] = [];
        actionableMacturingTaskBucketPeriod['status'] = manufacturingTaskBucketPeriod.status;
        for (const manufacturingSet of manufacturingTaskBucketPeriod.manufacturingSets) {
          actionableMacturingTaskBucketPeriod['manufacturingSets'].push(manufacturingSet);
          manufacturingSet['quantity'] = 0;
          manufacturingSet['sheets'] = 0;
          manufacturingSet['stack'] = 0;
          for (const printNodeOrderItem of manufacturingSet.printNodeOrderItems) {
            manufacturingSet['quantity'] += printNodeOrderItem.quantity;
            manufacturingSet['sheets'] += (printNodeOrderItem.book.body.width / 72 > 6 || printNodeOrderItem.book.body.height / 72 > 9) ? (printNodeOrderItem.book.body.numPages * printNodeOrderItem.quantity / 4) : (printNodeOrderItem.book.body.numPages * printNodeOrderItem.quantity / 8);
            manufacturingSet['stack'] += (printNodeOrderItem.book.body.width / 72 > 6 || printNodeOrderItem.book.body.height / 72 > 9) ? (printNodeOrderItem.book.body.numPages * printNodeOrderItem.quantity * 0.00474 / 4) : (printNodeOrderItem.book.body.numPages * printNodeOrderItem.quantity * 0.00474 / 8);
          }
        }
        actionableManufacturingTaskBucket['manufacturingTaskBucketPeriods'].push(actionableMacturingTaskBucketPeriod);
      }
      // this.actionableManufacturingTaskBuckets.push(actionableManufacturingTaskBucket);
      this.addActionableManufacturingTaskBucket(actionableManufacturingTaskBucket);
    // }
    // for (const manufacturingTaskBucket of this.manufacturingTaskBuckets) {
      for (const manufacturingTaskBucketPeriod of manufacturingTaskBucket.manufacturingTaskBucketPeriods) {
        const printNodeOrderItemsInManufacturingTaskBucketPeriod = [];
        for (const manufacturingSet of manufacturingTaskBucketPeriod.manufacturingSets) {
          this.computeProperties(manufacturingSet, manufacturingSet.printNodeOrderItems);
          for (const printNodeOrderItem of manufacturingSet.printNodeOrderItems) {
            printNodeOrderItemsInManufacturingTaskBucketPeriod.push(printNodeOrderItem);
          }
          manufacturingSet.printNodeOrderItems.sort((a, b): number => {
            const aPaperType = a.book.body.paperType_ID;
            const bPaperType = b.book.body.paperType_ID;
            if (aPaperType > bPaperType) {
              return -1;
            }
            if (aPaperType < bPaperType) {
              return 1;
            }
            const aNumPages = a.book.body.numPages;
            const bNumPages = b.book.body.numPages;
            if (aNumPages < bNumPages) {
              return -1;
            }
            if (aNumPages > bNumPages) {
              return 1;
            }
            return 0;
          });
        }
        this.computeProperties(manufacturingTaskBucketPeriod, printNodeOrderItemsInManufacturingTaskBucketPeriod); // TODO: Find a way to not recompute the printNodeOrderItems in this case
        manufacturingTaskBucketPeriod.manufacturingSets.sort((a, b): number => {
          const keys = ['interior', 'binding', 'lamination', 'impositionLayout', 'paperType', 'trimSize'];
          for (const key of keys) {
            const x = this.compare(a[key], b[key]);
            if (x !== 0) {
              return x;
            }
          }
          return 0;
        });
      }
    // }
  }

  getData(reset: boolean = false): void {
    this.startupService.touchLastUserActivity();
    this.manufacturingTaskBuckets = [];
    this.manufacturingTaskBucketService.getAddNotifier(false).pipe(takeUntil(this.onDestroySubject)).subscribe(o => {
      console.log(`In ManufacturingBuckets got Add Notification for ManufacturingTaskBucket for object [${o.ID}]`);
      this.addUpdateManufacturingTaskBucket(o);
    });
    this.manufacturingTaskBucketService.getUpdateNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe(o => {
      console.log(`In ManufacturingBuckets got Update Notification for ManufacturingTaskBucket for object [${o.ID}]`);
      this.addUpdateManufacturingTaskBucket(o);
    });
    this.manufacturingTaskBucketService.getDeleteNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe(o => {
      console.log(`In ManufacturingBuckets got Delete Notification for ManufacturingTaskBucket for object [${o.ID}]`);
      this.deleteManufacturingTaskBucket(o);
    });
    this.manufacturingTaskBucketService.objects.forEach(o => {
      // console.log(`In ManufacturingBuckets initial ForEach for ManufacturingTaskBucket for object [${o.ID}]`);
      this.addUpdateManufacturingTaskBucket(o);
    });

    this.manufacturingTaskBucketPeriodService.getAddNotifier(false).pipe(takeUntil(this.onDestroySubject)).subscribe(o => {
      console.log(`In ManufacturingBuckets got Add Notification for ManufacturingTaskBucketPeriod for object [${o.ID}]`);
      this.addUpdateManufacturingTaskBucketPeriod(o);
    });
    this.manufacturingTaskBucketPeriodService.getUpdateNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe(o => {
      console.log(`In ManufacturingBuckets got Update Notification for ManufacturingTaskBucketPeriod for object [${o.ID}]`);
      this.addUpdateManufacturingTaskBucketPeriod(o);
    });
    this.manufacturingTaskBucketPeriodService.getDeleteNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe(o => {
      console.log(`In ManufacturingBuckets got Delete Notification for ManufacturingTaskBucketPeriod for object [${o.ID}]`);
      this.deleteManufacturingTaskBucketPeriod(o);
    });
    this.manufacturingTaskBucketPeriodService.objects.forEach(o => {
      // console.log(`In ManufacturingBuckets got initial ForEach for ManufacturingTaskBucketPeriod for object [${o.ID}]`);
      this.addUpdateManufacturingTaskBucketPeriod(o);
    });

    this.manufacturingSetService.getAddNotifier(false).pipe(takeUntil(this.onDestroySubject)).subscribe(o => {
      console.log(`In ManufacturingBuckets got Add Notification for ManufacturingSet for object [${o.ID}]`);
      this.addUpdateManufacturingSet(o);
    });
    this.manufacturingSetService.getUpdateNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe(o => {
      console.log(`In ManufacturingBuckets got Update Notification for ManufacturingSet for object [${o.ID}]`);
      this.addUpdateManufacturingSet(o);
    });
    this.manufacturingSetService.getDeleteNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe(o => {
      console.log(`In ManufacturingBuckets got Delete Notification for ManufacturingSet for object [${o.ID}]`);
      this.deleteManufacturingSet(o);
    });
    this.manufacturingSetService.objects.forEach(o => {
      // console.log(`In ManufacturingBuckets got initial ForEach for ManufacturingSet for object [${o.ID}]`);
      this.addUpdateManufacturingSet(o);
    });

    this.printNodeOrderItemService.getAddNotifier(true).pipe(takeUntil(this.onDestroySubject)).subscribe(o => {
      console.log(`In ManufacturingBuckets got Add Notification for PrintNodeOrderItem for object [${o.ID}]`);
      this.addUpdatePrintNodeOrderItem(o);
    });
    this.printNodeOrderItemService.getUpdateNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe(o => {
      console.log(`In ManufacturingBuckets got Update Notification for PrintNodeOrderItem for object [${o.ID}]`);
      NotificationsService.trace(`6. ManufacturingBucketsComponent received PrintNodeOrderItem UPDATE id[${o.ID}]`
        + ` manufacturingset_id[${o.manufacturingset_id}]`
        + ` resolvedSet[${o.manufacturingSet ? o.manufacturingSet.ID : 'none'}]`
        + ` previouslySeenInBucket[${this.lastKnownBucketIdByPrintNodeOrderItemId[o.ID]}]`
        + ` bucket[${o.manufacturingSet && o.manufacturingSet.manufacturingTaskBucketPeriod && o.manufacturingSet.manufacturingTaskBucketPeriod.manufacturingTaskBucket ? o.manufacturingSet.manufacturingTaskBucketPeriod.manufacturingTaskBucket.ID : 'unresolved'}]`);
      this.addUpdatePrintNodeOrderItem(o);
    });
    this.printNodeOrderItemService.objects.forEach(o => {
      // console.log(`In ManufacturingBuckets got initial ForEach for PrintNodeOrderItem for object [${o.ID}]`);
      this.addUpdatePrintNodeOrderItem(o);
    });

    this.facilityInventoryProductService.getAddNotifier(true).pipe(takeUntil(this.onDestroySubject)).subscribe(o => {
      console.log(`In ManufacturingBuckets got Add Notification for FacilityInventoryProduct for object [${o.ID}]`);
      this.addUpdateFacilityInventoryProduct(o);
    });
    this.facilityInventoryProductService.getUpdateNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe(o => {
      console.log(`In ManufacturingBuckets got Update Notification for FacilityInventoryProduct for object [${o.ID}]`);
      this.addUpdateFacilityInventoryProduct(o);
    });
    this.facilityInventoryProductService.objects.forEach(o => {
      // console.log(`In ManufacturingBuckets got initial ForEach for FacilityInventoryProduct for object [${o.ID}]`);
      this.addUpdateFacilityInventoryProduct(o);
    });

    // const filter = {
    //   eq: {},
    //   ge: {},
    //   ne: {}
    // };
    // filter['eq']['printNodeOrder.shippingStatus'] = 'NONE';
    // filter['eq']['printNodeOrderItem.manufacturingTaskBucketPeriod_id'] = 0;
    // filter['eq']['printNodeOrder.printnode_ID'] = 3;
    //
    //
    // this.facilityInventoryProductService.getItems()
    //   .subscribe(facilityInventoryProducts => {
    //     this.facilityInventoryProducts = facilityInventoryProducts;
    //   });
    //
    // const manufacturingTaskBucketFilter = {
    //   eq: {
    //     ' date_add(date(substring(manufacturingTaskBucketPeriod.period, 2, 10)), INTERVAL 6 DAY) > now() ': 1,
    //     ' date_add(date(substring(manufacturingTaskBucketPeriod.period, 2, 10)), INTERVAL -6 DAY) < now() ': 1
    //   }
    // };
    // this.manufacturingTaskBucketService.getFilteredItems(manufacturingTaskBucketFilter, reset, 1)
    //   .subscribe(manufacturingTaskBuckets => {
    //     this.manufacturingTaskBuckets = manufacturingTaskBuckets;
    //   });
  }

  compare(aObject: any, bObject: any) {
    const a = Object.keys(aObject['0'])[0];
    const b = Object.keys(bObject['0'])[0];
    if (a > b) {
      return 1;
    } else if (a < b) {
      return -1;
    }
    return 0;
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.onDestroySubject.next(true);
    this.onDestroySubject.unsubscribe();
  }

  isPrintNodeOrderItemCompatableWithManufacturingSet(printNodeOrderItem: PrintNodeOrderItem, manufacturingSet: ManufacturingSet): boolean {
    if (manufacturingSet.openStatus === 'CLOSED') {
      return false;
    }
    if (manufacturingSet.details && manufacturingSet.details['SinglesOrBatch'] && manufacturingSet.details['SinglesOrBatch'] !== 'SINGLES' && printNodeOrderItem.quantity < 18) {
      return false;
    }
    if (manufacturingSet.details && manufacturingSet.details['trimSizeBreaks'] && manufacturingSet.details['trimSizeBreaks'] === '_4UP' && (printNodeOrderItem.book.body.height / 72 > 9 || printNodeOrderItem.book.body.width / 72 > 6)) {
      return false;
    }
    if (manufacturingSet.details && manufacturingSet.details['laminateType'] && manufacturingSet.details['laminateType'] !== printNodeOrderItem.book.cover.laminateType) {
      return false;
    }
    return true;
  }

  computeProperties(wrapper: any, printNodeOrderItems: PrintNodeOrderItem[]) {
    if (!wrapper.filter) {
      wrapper.filter = {};
    }

    if ( wrapper.ID === 52444) {
      console.log('Matched on Set Id');
    }
    // wrapper.filter['paperType.4'] = true;
    wrapper.productiveSheets = 0;
    wrapper.productiveUnits = 0;
    wrapper.totalSheets = 0;
    wrapper.totalUnits = 0;
    wrapper.totalRevenue = 0;
    wrapper.unproductivePages = 0;
    wrapper.layers = [];
    wrapper.lineItems = 0;
    wrapper.quantity = 0;
    wrapper.feetOrSheets = 0;
    wrapper.totals = [0, 0, 0];
    wrapper.binding = [{}, {}, {}];
    wrapper.lamination = [{}, {}, {}];
    wrapper.paperType = [{}, {}, {}];
    wrapper.createdDate = [{}, {}, {}];
    wrapper.trimSize = [{}, {}, {}];
    wrapper.interior = [{}, {}, {}];
    wrapper.impositionLayout = [{}, {}, {}];
    wrapper.quantityGroup = [{}, {}, {}];
    wrapper.serviceProvider = [{}, {}, {}];
    wrapper.oneDigitZip = [{}, {}, {}];

    const MIN_PAGES_PER_BOOK = 24;
    let bodyBooksPerUnit = 4; // Books Per Layer
    let index = 0;
    const flattenedPrintNodeOrderItems = [];
    const flattenedPrintNodeOrderItemIndexInPrintNodeOrderItem = [];
    const flattenedLayer = [];
    const flattenedUnproductivePages = [];
    const flattenedPages = [];
    const flattenedLayerPages = [];
    let extraPrinted = 0;
    if ( printNodeOrderItems[0] && printNodeOrderItems[0].quantity < 15 && printNodeOrderItems[0].book ) { // Compute the unproductive pages in each printNodeOrderItem based on the layers in the set
      bodyBooksPerUnit = printNodeOrderItems[0].book.body.width / 72 > 6 || printNodeOrderItems[0].book.body.height / 72 > 9 ? 2 : 4; // Books Per Layer

      // Expand PrintNodeOrderItems like the server does
      const sortedByPagesPrintNodeOrderItems = printNodeOrderItems.sort((a, b) => {
        const ap = Math.max(MIN_PAGES_PER_BOOK, a.book.body.paperType_ID);
        const bp = Math.max(MIN_PAGES_PER_BOOK, b.book.body.paperType_ID);
        const ax = Math.max(MIN_PAGES_PER_BOOK, a.book.body.numPages);
        const bx = Math.max(MIN_PAGES_PER_BOOK, b.book.body.numPages);
        if (ap < bp) {
          return -1;
        }
        if (ap > bp) {
          return 1;
        }
        if (ax < bx) {
          return -1;
        }
        if (ax > bx) {
          return 1;
        }
        return 0;
      });
      const paperTypes = {};
      for (let i = 0; i < sortedByPagesPrintNodeOrderItems.length; i++) {
        const printNodeOrderItem = sortedByPagesPrintNodeOrderItems[i];
        printNodeOrderItem['expandedQuantity'] = printNodeOrderItem.quantity;
        const paperType = printNodeOrderItem.book.body.paperType_ID;
        if (!paperTypes[paperType]) {
          paperTypes[paperType] = [];
        }
        paperTypes[paperType].push(printNodeOrderItem);
      }

      // const expandedPrintNodeOrderItems: PrintNodeOrderItem[] = [];
      // let layers = 0;
      for (const paperType of Object.keys(paperTypes)) {
        const paperTypePrintNodeOrderItems = paperTypes[paperType];
        let maxQuantityPrintNodeOrderItem: PrintNodeOrderItem = paperTypePrintNodeOrderItems[0];
        let maxMinus1QuantityPrintNodeOrderItem: PrintNodeOrderItem = paperTypePrintNodeOrderItems.length > 1 ? paperTypePrintNodeOrderItems[1] : paperTypePrintNodeOrderItems[0];
        let maxMinus2QuantityPrintNodeOrderItem: PrintNodeOrderItem = paperTypePrintNodeOrderItems.length > 2 ? paperTypePrintNodeOrderItems[2] : (paperTypePrintNodeOrderItems.length > 1 ? paperTypePrintNodeOrderItems[1] : paperTypePrintNodeOrderItems[0]);
        let totalQuantity = 0;
        for (const printNodeOrderItem of paperTypePrintNodeOrderItems) {
          if (maxQuantityPrintNodeOrderItem.quantity < printNodeOrderItem.quantity) {
            maxMinus2QuantityPrintNodeOrderItem = maxMinus1QuantityPrintNodeOrderItem;
            maxMinus1QuantityPrintNodeOrderItem = maxQuantityPrintNodeOrderItem;
            maxQuantityPrintNodeOrderItem = printNodeOrderItem;
          }
          totalQuantity += printNodeOrderItem.quantity;
        }
        const paperTypeLayers = Math.ceil(totalQuantity / bodyBooksPerUnit);
        // layers += paperTypeLayers;
        const quantityNeededToEvenLayers = paperTypeLayers * bodyBooksPerUnit - totalQuantity;
        for (const printNodeOrderItem of paperTypePrintNodeOrderItems) {
          if (quantityNeededToEvenLayers >= 1 && maxQuantityPrintNodeOrderItem === printNodeOrderItem) {
            printNodeOrderItem['expandedQuantity']++;
            extraPrinted++;
            // expandedPrintNodeOrderItems.push(printNodeOrderItem);
          }
          if (quantityNeededToEvenLayers >= 2 && maxMinus1QuantityPrintNodeOrderItem === printNodeOrderItem) {
            printNodeOrderItem['expandedQuantity']++;
            extraPrinted++;
            // expandedPrintNodeOrderItems.push(printNodeOrderItem);
          }
          if (quantityNeededToEvenLayers >= 3 && maxMinus2QuantityPrintNodeOrderItem === printNodeOrderItem) {
            printNodeOrderItem['expandedQuantity']++;
            extraPrinted++;
            // expandedPrintNodeOrderItems.push(printNodeOrderItem);
          }
          // for (let i = 0; i < printNodeOrderItem.quantity; i++) {
          //   expandedPrintNodeOrderItems.push(printNodeOrderItem);
          // }
        }
      }
      // End of Expand PrintNodeOrderItems like the server does

      for (const printNodeOrderItem of printNodeOrderItems) {
        printNodeOrderItem['sheets'] = [];
        printNodeOrderItem['unproductivePages'] = [];
        printNodeOrderItem['layer'] = [];
        for (let printNodeOrderItemQuantityIndex = 0; printNodeOrderItemQuantityIndex < printNodeOrderItem['expandedQuantity']; printNodeOrderItemQuantityIndex++) {
          const currentLayer = Math.floor(index / bodyBooksPerUnit);
          flattenedPrintNodeOrderItems.push(printNodeOrderItem);
          flattenedPrintNodeOrderItemIndexInPrintNodeOrderItem.push(printNodeOrderItemQuantityIndex);
          printNodeOrderItem['sheets'].push(0);
          printNodeOrderItem['unproductivePages'].push(0);
          flattenedUnproductivePages.push(0);
          flattenedPages.push(0);
          flattenedLayerPages.push(0);
          printNodeOrderItem['layer'].push(currentLayer);
          flattenedLayer.push(currentLayer);
          index++;
        }
      }
      let layerPages = 0;
      let layerSheets = 0;
      for ( let i = 0; i < flattenedPrintNodeOrderItems.length; i++ ) {
        const printNodeOrderItem = flattenedPrintNodeOrderItems[i];
        if (i % bodyBooksPerUnit === 0) { // Start of a new layer
          if ( i + bodyBooksPerUnit - 1 < flattenedPrintNodeOrderItems.length ) {
            const largestPrintNodeOrderItemInLayer = flattenedPrintNodeOrderItems [i + bodyBooksPerUnit - 1];
            layerPages = (Math.ceil(largestPrintNodeOrderItemInLayer.book.body.numPages / 2) * 2);
          } else {
            if ( i + bodyBooksPerUnit - 2 < flattenedPrintNodeOrderItems.length ) {
              const largestPrintNodeOrderItemInLayer = flattenedPrintNodeOrderItems [i + bodyBooksPerUnit - 2];
              layerPages = (Math.ceil(largestPrintNodeOrderItemInLayer.book.body.numPages / 2) * 2);
            } else {
              if ( i + bodyBooksPerUnit - 3 < flattenedPrintNodeOrderItems.length ) {
                const largestPrintNodeOrderItemInLayer = flattenedPrintNodeOrderItems [i + bodyBooksPerUnit - 3];
                layerPages = (Math.ceil(largestPrintNodeOrderItemInLayer.book.body.numPages / 2) * 2);
              } else {
                if ( i + bodyBooksPerUnit - 4 < flattenedPrintNodeOrderItems.length ) {
                  const largestPrintNodeOrderItemInLayer = flattenedPrintNodeOrderItems [i + bodyBooksPerUnit - 4];
                  layerPages = (Math.ceil(largestPrintNodeOrderItemInLayer.book.body.numPages / 2) * 2);
                }
              }
            }
          }
        }
        layerSheets = (layerPages / bodyBooksPerUnit) / 2;
        printNodeOrderItem['sheets'][flattenedPrintNodeOrderItemIndexInPrintNodeOrderItem[i]] = layerSheets;
        if ( flattenedPrintNodeOrderItemIndexInPrintNodeOrderItem[i] < printNodeOrderItem.quantity ) {
          printNodeOrderItem['unproductivePages'][flattenedPrintNodeOrderItemIndexInPrintNodeOrderItem[i]] = layerPages - (Math.ceil(printNodeOrderItem.book.body.numPages / 2) * 2);
        } else {
          printNodeOrderItem['unproductivePages'][flattenedPrintNodeOrderItemIndexInPrintNodeOrderItem[i]] = layerPages; // This could be not all of the pages if the extra is usable
        }
        flattenedUnproductivePages[i] = layerPages - (Math.ceil(printNodeOrderItem.book.body.numPages / 2) * 2);
        flattenedPages[i] = (Math.ceil(printNodeOrderItem.book.body.numPages / 2) * 2);
        flattenedLayerPages[i] = layerPages;
      }

      //
      //
      // const printNodeOrderItemsTest = [];
      // const printNodeOrderItemsQuantityItemTest = [];
      // const printNodeOrderItemsUnproductivePages = [];
      // const printNodeOrderItemsSheetsTest = [];
      // const printNodeOrderItemsLayerTest = [];
      //
      // index = 0;
      // let previousPrintNodeOrderItemsInLayer = [];
      // let previousPrintNodeOrderItemsInLayerIndexWithinPrintNodeOrderItem = [];
      // for (const printNodeOrderItem of printNodeOrderItems) {
      //   printNodeOrderItem['sheets'] = [];
      //   printNodeOrderItem['unproductivePages'] = [];
      //   printNodeOrderItem['layer'] = [];
      //   printNodeOrderItem['index'] = [];
      //   for ( let printNodeOrderItemQuantityIndex = 0; printNodeOrderItemQuantityIndex < printNodeOrderItem.quantity; printNodeOrderItemQuantityIndex++ ) {
      //     const currentLayer = Math.floor( index / bodyBooksPerUnit );
      //     if ( index % bodyBooksPerUnit === 0 ) { // Start of a new layer
      //       previousPrintNodeOrderItemsInLayer = [];
      //       previousPrintNodeOrderItemsInLayerIndexWithinPrintNodeOrderItem = [];
      //     }
      //     for ( let i = 0; i < previousPrintNodeOrderItemsInLayer.length; i++ ) {
      //       const previousPrintNodeOrderItemInLayer = previousPrintNodeOrderItemsInLayer[i];
      //       const quantityIndexWithinPreviousPrintNodeOrderItemInLayer = previousPrintNodeOrderItemsInLayerIndexWithinPrintNodeOrderItem[i];
      //       previousPrintNodeOrderItemInLayer['sheets'][quantityIndexWithinPreviousPrintNodeOrderItemInLayer] = ( ( Math.ceil(printNodeOrderItem.book.body.numPages / 2 ) * 2 ) / bodyBooksPerUnit ) / 2; // Final divide by 2 to get from pages to sheets
      //       previousPrintNodeOrderItemInLayer['unproductivePages'][quantityIndexWithinPreviousPrintNodeOrderItemInLayer] = ( Math.ceil(printNodeOrderItem.book.body.numPages / 2 ) * 2 ) - ( Math.ceil(previousPrintNodeOrderItemInLayer.book.body.numPages / 2 ) * 2 );
      //       printNodeOrderItemsUnproductivePages[previousPrintNodeOrderItemInLayer['index'][quantityIndexWithinPreviousPrintNodeOrderItemInLayer]] = ( Math.ceil(printNodeOrderItem.book.body.numPages / 2 ) * 2 ) - ( Math.ceil(previousPrintNodeOrderItemInLayer.book.body.numPages / 2 ) * 2 );
      //       console.log('');
      //     }
      //     printNodeOrderItemsTest.push(printNodeOrderItem);
      //     printNodeOrderItemsQuantityItemTest.push(printNodeOrderItemQuantityIndex);
      //     printNodeOrderItemsUnproductivePages.push(0);
      //     printNodeOrderItemsSheetsTest.push(( ( Math.ceil(printNodeOrderItem.book.body.numPages / 2 ) * 2 ) / bodyBooksPerUnit ) / 2 );
      //     printNodeOrderItemsLayerTest.push(currentLayer);
      //     printNodeOrderItem['sheets'].push(( ( Math.ceil(printNodeOrderItem.book.body.numPages / 2 ) * 2 ) / bodyBooksPerUnit ) / 2 ); // Final divide by 2 to get from pages to sheets
      //     printNodeOrderItem['unproductivePages'].push(0);
      //     printNodeOrderItem['layer'].push(currentLayer);
      //     printNodeOrderItem['index'].push(index);
      //     previousPrintNodeOrderItemsInLayer.push(printNodeOrderItem);
      //     previousPrintNodeOrderItemsInLayerIndexWithinPrintNodeOrderItem.push(printNodeOrderItemQuantityIndex);
      //     index++;
      //   }
      // }
    }
    // if ( flattenedUnproductivePages.length > 0) {
    //   console.log(`ID ${wrapper.ID} flattenedUnproductivePages ${JSON.stringify(flattenedUnproductivePages)}`);
    //   console.log(`ID ${wrapper.ID} flattenedLayer ${JSON.stringify(flattenedLayer)}`);
    //   console.log(`ID ${wrapper.ID} flattenedPages ${JSON.stringify(flattenedPages)}`);
    //   console.log(`ID ${wrapper.ID} flattenedPrintNodeOrderItemIndexInPrintNodeOrderItem ${JSON.stringify(flattenedPrintNodeOrderItemIndexInPrintNodeOrderItem)}`);
    //   console.log(`ID ${wrapper.ID} flattenedLayerPages ${JSON.stringify(flattenedLayerPages)}`);
    // }
    if ( wrapper.ID === 52444) {
      console.log('Matched on Set Id');
    }
    for (const printNodeOrderItem of printNodeOrderItems) {
      try {
        const quantity = printNodeOrderItem.quantity;
        const width = printNodeOrderItem.book.body.width;
        const height = printNodeOrderItem.book.body.height;
        const thickness = printNodeOrderItem.book.body.spine;
        const pages = Math.ceil(printNodeOrderItem.book.body.numPages / 2 ) * 2;
        const interior = printNodeOrderItem.book.interiorType;
        const paperType = String(printNodeOrderItem.book.body.paperType_ID);
        const lamination = printNodeOrderItem.book.cover.laminateType;

        let createdDate = '';
        let oneDigitZip = '';
        let serviceProvider = 0;
        if (printNodeOrderItem.printNodeOrder) {
          createdDate = new Date(printNodeOrderItem.printNodeOrder.created).toISOString().split('T')[0];
          oneDigitZip = ManufacturingBucketsComponent.getFacilityBasedOnCountryStateAndOneDigitZip(printNodeOrderItem.printNodeOrder.country, printNodeOrderItem.printNodeOrder.state, printNodeOrderItem.printNodeOrder.postalcode ? printNodeOrderItem.printNodeOrder.postalcode.substring(0, 1) : '', printNodeOrderItem.printNodeOrder.printnode_ID);
          if (printNodeOrderItem.printNodeOrder.organization) {
            serviceProvider = printNodeOrderItem.printNodeOrder.organization.serviceProvider_ID;
          }
        }
        // const createdDate = new Date(printNodeOrderItem.printNodeOrder.created).toISOString().split('T')[0];

        const binding = printNodeOrderItem.book.bindingType;
        let trimSize = '';
        if (width / 72 === 5.5 && height / 72 === 8.5) {
          trimSize = '_5.5X8.5';
        } else {
          if (width / 72 === 6.0 && height / 72 === 9.0) {
            trimSize = '_6.0X9.0';
          } else {
            if (width / 72 === 8.5 && height / 72 === 11) {
              trimSize = '_8.5X11.0';
            } else {
              trimSize = 'Other';
            }
          }
        }

        let impositionLayout = width / 72 > 6 || height / 72 > 9 ? '_2UP' : '_4UP';
        let feetOrSheets = width / 72 > 6 || height / 72 > 9 ? quantity * pages / 4 : quantity * pages / 8;
        // Get a criteria to determine that it is comming off of a roll to make it feet
        if (false) {
          feetOrSheets = width / 72 > 6 || height / 72 > 9 ? quantity * pages / 4 : (quantity * pages / 6) * 10 / 12;
          impositionLayout = width / 72 > 6 || height / 72 > 9 ? '_2UP' : '_3UP';
        }

        let quantityGroup = '_001-019';
        if (quantity < 20) {
          quantityGroup = '_001-019';
        } else {
          if (quantity < 50) {
            quantityGroup = '_020-049';
          } else {
            if (quantity < 100) {
              quantityGroup = '_050-099';
            } else {
              if (quantity < 250) {
                quantityGroup = '_100-249';
              } else {
                if (quantity < 500) {
                  quantityGroup = '_250-499';
                } else {
                  quantityGroup = '_500+';
                }
              }
            }
          }
        }

        if ( quantity < 15 ) { // Singles
          wrapper.unproductivePages += printNodeOrderItem['unproductivePages'].reduce((total, current) => total + current, 0);
          wrapper.productiveSheets += (printNodeOrderItem['sheets'].reduce((total, current) => total + current, 0) - (width / 72 > 6 || height / 72 > 9 ? printNodeOrderItem['unproductivePages'].reduce((total, current) => total + current, 0) / 4 : printNodeOrderItem['unproductivePages'].reduce((total, current) => total + current, 0) / 8));
          wrapper.totalSheets += printNodeOrderItem['sheets'].reduce((total, current) => total + current, 0);
          wrapper.totalUnits += quantity;
          wrapper.productiveUnits = wrapper.totalUnits - extraPrinted;
          wrapper.totalRevenue += ManufacturingBucketsComponent.getRevenue(printNodeOrderItem) * printNodeOrderItem.quantity;
        } else { // Batch
          bodyBooksPerUnit = width / 72 > 6 || height / 72 > 9 ? 2 : 4; // Books Per Layer
          let wasteAccomodationFactor = 1.03;
          let printQuantity = Math.ceil(((quantity * wasteAccomodationFactor) / bodyBooksPerUnit) - 0.1) * bodyBooksPerUnit;
          const maxExtraBooksPrinted = Math.ceil(((quantity + 16 ) / bodyBooksPerUnit)) * bodyBooksPerUnit;
          printQuantity = Math.min(printQuantity, maxExtraBooksPrinted);
          if (quantity < 40) {
            wasteAccomodationFactor = 1;
            printQuantity = Math.ceil((quantity * wasteAccomodationFactor) / bodyBooksPerUnit) * bodyBooksPerUnit;
          }
          wrapper.productiveSheets += width / 72 > 6 || height / 72 > 9 ? quantity * pages / 4 : quantity * pages / 8;
          wrapper.productiveUnits += quantity; // Same as wrapper.quantity
          wrapper.totalSheets  += width / 72 > 6 || height / 72 > 9 ? printQuantity * pages / 4 : printQuantity * pages / 8;
          wrapper.totalUnits += printQuantity;
          wrapper.totalRevenue += ManufacturingBucketsComponent.getRevenue(printNodeOrderItem) * printNodeOrderItem.quantity;
        }


        wrapper.lineItems += 1;
        wrapper.quantity += quantity;
        wrapper.feetOrSheets += feetOrSheets;
        wrapper.totals[0] += quantity;
        wrapper.totals[1] += feetOrSheets;
        wrapper.totals[2] += 1;
        if (!wrapper.quantityGroup[0][quantityGroup]) {
          wrapper.quantityGroup[0][quantityGroup] = 0;
        }
        if (!wrapper.quantityGroup[1][quantityGroup]) {
          wrapper.quantityGroup[1][quantityGroup] = 0;
        }
        if (!wrapper.quantityGroup[2][quantityGroup]) {
          wrapper.quantityGroup[2][quantityGroup] = 0;
        }
        wrapper.quantityGroup[0][quantityGroup] += quantity;
        wrapper.quantityGroup[1][quantityGroup] += feetOrSheets;
        wrapper.quantityGroup[2][quantityGroup] += 1;

        if (!wrapper.binding[0][binding]) {
          wrapper.binding[0][binding] = 0;
        }
        if (!wrapper.binding[1][binding]) {
          wrapper.binding[1][binding] = 0;
        }
        if (!wrapper.binding[2][binding]) {
          wrapper.binding[2][binding] = 0;
        }
        wrapper.binding[0][binding] += quantity;
        wrapper.binding[1][binding] += feetOrSheets;
        wrapper.binding[2][binding] += 1;

        if (!wrapper.paperType[0][paperType]) {
          wrapper.paperType[0][paperType] = 0;
        }
        if (!wrapper.paperType[1][paperType]) {
          wrapper.paperType[1][paperType] = 0;
        }
        if (!wrapper.paperType[2][paperType]) {
          wrapper.paperType[2][paperType] = 0;
        }
        wrapper.paperType[0][paperType] += quantity;
        wrapper.paperType[1][paperType] += feetOrSheets;
        wrapper.paperType[2][paperType] += 1;

        if (!wrapper.trimSize[0][trimSize]) {
          wrapper.trimSize[0][trimSize] = 0;
        }
        if (!wrapper.trimSize[1][trimSize]) {
          wrapper.trimSize[1][trimSize] = 0;
        }
        if (!wrapper.trimSize[2][trimSize]) {
          wrapper.trimSize[2][trimSize] = 0;
        }
        wrapper.trimSize[0][trimSize] += quantity;
        wrapper.trimSize[1][trimSize] += feetOrSheets;
        wrapper.trimSize[2][trimSize] += 1;

        if (!wrapper.createdDate[0][createdDate]) {
          wrapper.createdDate[0][createdDate] = 0;
        }
        if (!wrapper.createdDate[1][createdDate]) {
          wrapper.createdDate[1][createdDate] = 0;
        }
        if (!wrapper.createdDate[2][createdDate]) {
          wrapper.createdDate[2][createdDate] = 0;
        }
        wrapper.createdDate[0][createdDate] += quantity;
        wrapper.createdDate[1][createdDate] += feetOrSheets;
        wrapper.createdDate[2][createdDate] += 1;

        if (!wrapper.lamination[0][lamination]) {
          wrapper.lamination[0][lamination] = 0;
        }
        if (!wrapper.lamination[1][lamination]) {
          wrapper.lamination[1][lamination] = 0;
        }
        if (!wrapper.lamination[2][lamination]) {
          wrapper.lamination[2][lamination] = 0;
        }
        wrapper.lamination[0][lamination] += quantity;
        wrapper.lamination[1][lamination] += feetOrSheets;
        wrapper.lamination[2][lamination] += 1;

        if (!wrapper.interior[0][interior]) {
          wrapper.interior[0][interior] = 0;
        }
        if (!wrapper.interior[1][interior]) {
          wrapper.interior[1][interior] = 0;
        }
        if (!wrapper.interior[2][interior]) {
          wrapper.interior[2][interior] = 0;
        }
        wrapper.interior[0][interior] += quantity;
        wrapper.interior[1][interior] += feetOrSheets;
        wrapper.interior[2][interior] += 1;

        if (!wrapper.impositionLayout[0][impositionLayout]) {
          wrapper.impositionLayout[0][impositionLayout] = 0;
        }
        if (!wrapper.impositionLayout[1][impositionLayout]) {
          wrapper.impositionLayout[1][impositionLayout] = 0;
        }
        if (!wrapper.impositionLayout[2][impositionLayout]) {
          wrapper.impositionLayout[2][impositionLayout] = 0;
        }
        wrapper.impositionLayout[0][impositionLayout] += quantity;
        wrapper.impositionLayout[1][impositionLayout] += feetOrSheets;
        wrapper.impositionLayout[2][impositionLayout] += 1;

        if (!wrapper.oneDigitZip[0][oneDigitZip]) {
          wrapper.oneDigitZip[0][oneDigitZip] = 0;
        }
        if (!wrapper.oneDigitZip[1][oneDigitZip]) {
          wrapper.oneDigitZip[1][oneDigitZip] = 0;
        }
        if (!wrapper.oneDigitZip[2][oneDigitZip]) {
          wrapper.oneDigitZip[2][oneDigitZip] = 0;
        }
        wrapper.oneDigitZip[0][oneDigitZip] += quantity;
        wrapper.oneDigitZip[1][oneDigitZip] += feetOrSheets;
        wrapper.oneDigitZip[2][oneDigitZip] += 1;

        if (!wrapper.serviceProvider[0][serviceProvider]) {
          wrapper.serviceProvider[0][serviceProvider] = 0;
        }
        if (!wrapper.serviceProvider[1][serviceProvider]) {
          wrapper.serviceProvider[1][serviceProvider] = 0;
        }
        if (!wrapper.serviceProvider[2][serviceProvider]) {
          wrapper.serviceProvider[2][serviceProvider] = 0;
        }
        wrapper.serviceProvider[0][serviceProvider] += quantity;
        wrapper.serviceProvider[1][serviceProvider] += feetOrSheets;
        wrapper.serviceProvider[2][serviceProvider] += 1;
      } catch (e) {
        console.log(`Error setting up Wrapper Properties for a ManufacturingSet ${e.message}`);
      }

    }
  }

  getTypes(): string[] {
    return ManufacturingSetsComponent.types;
  }

  getFilter(list: any, type: any): string[] {
    return Object.keys(list[type][0]);
  }

  getCategories(list: any, type: any): string[] {
    if (list && list[type] && list[type][0]) {
      return Object.keys(list[type][0]);
    } else {
      return ['', '', ''];
    }
  }

  getCategoryData(list: any, type: any, dataIndex: any): number[] {
    return list[type][dataIndex];
  }

  getColor(type: any): any {
    return ManufacturingSetsComponent.colors[type];
  }

  getIcons(type: any): any {
    return ManufacturingSetsComponent.icons[type];
  }

  filtered(list: any, printNodeOrderItem: PrintNodeOrderItem): boolean {
    if (!list.filter) {
      return false;
    }
    for (const key of Object.keys(list.filter)) {
      const parts = key.split('*');
      if (parts.length === 2) {
        switch (parts[0]) {
          case 'interior': {
            if (String(printNodeOrderItem.book.interiorType) === parts[1]) {
              return true;
            }
            break;
          }
          case 'paperType': {
            if (String(printNodeOrderItem.book.body.paperType_ID) === parts[1]) {
              return true;
            }
            break;
          }
          case 'lamination': {
            if (printNodeOrderItem.book.cover.laminateType === parts[1]) {
              return true;
            }
            break;
          }
          case 'binding': {
            if (printNodeOrderItem.book.bindingType === parts[1]) {
              return true;
            }
            break;
          }
          case 'trimSize': {
            if (printNodeOrderItem.book.body.width / 72 === 5.5 && printNodeOrderItem.book.body.height / 72 === 8.5) {
              if (parts[1] === '_5.5X8.5') {
                return true;
              }
            } else {
              if (printNodeOrderItem.book.body.width / 72 === 6.0 && printNodeOrderItem.book.body.height / 72 === 9.0) {
                if (parts[1] === '_6.0X9.0') {
                  return true;
                }
              } else {
                if (printNodeOrderItem.book.body.width / 72 === 8.5 && printNodeOrderItem.book.body.height / 72 === 11) {
                  if (parts[1] === '_8.5X11.0') {
                    return true;
                  }
                } else {
                  if (parts[1] === 'Other') {
                    return true;
                  }
                }
              }
            }
            break;
          }
          case 'impositionLayout': {
            if (printNodeOrderItem.book.body.width / 72 > 6 || printNodeOrderItem.book.body.height / 72 > 9) {
              if (parts[1] === '_2UP') {
                return true;
              }
            } else {
              if (parts[1] === '_4UP') {
                return true;
              }
            }
            break;
          }
          case 'quantityGroup': {
            if (printNodeOrderItem.quantity < 20) {
              if (parts[1] === '_001-019') {
                return true;
              }
            } else {
              if (printNodeOrderItem.quantity >= 20 && printNodeOrderItem.quantity < 50) {
                if (parts[1] === '_020-049') {
                  return true;
                }
              } else {
                if (printNodeOrderItem.quantity >= 50 && printNodeOrderItem.quantity < 100) {
                  if (parts[1] === '_050-099') {
                    return true;
                  }
                } else {
                  if (printNodeOrderItem.quantity >= 100 && printNodeOrderItem.quantity < 250) {
                    if (parts[1] === '_100-249') {
                      return true;
                    }
                  } else {
                    if (printNodeOrderItem.quantity >= 250 && printNodeOrderItem.quantity < 500) {
                      if (parts[1] === '_250-499') {
                        return true;
                      }
                    } else {
                      if (printNodeOrderItem.quantity >= 500) {
                        if (parts[1] === '_500+') {
                          return true;
                        }
                      }
                    }
                  }
                }
              }
            }
            break;
          }
          case 'oneDigitZip': {
            const oneDigitZip = ManufacturingBucketsComponent.getFacilityBasedOnCountryStateAndOneDigitZip(printNodeOrderItem.printNodeOrder.country, printNodeOrderItem.printNodeOrder.state, printNodeOrderItem.printNodeOrder.postalcode ? printNodeOrderItem.printNodeOrder.postalcode.substring(0, 1) : '', printNodeOrderItem.printNodeOrder.printnode_ID);
            if (oneDigitZip === parts[1]) {
              return true;
            }
            break;
          }
          default: {
            return false;
          }
        }
      }
    }
    return false;
  }

  toggleManufacturingSetOpenStatus(manufacturingSet: ManufacturingSet) {
    if (manufacturingSet.openStatus === 'OPEN') {
      manufacturingSet.openStatus = 'CLOSED';
    } else {
      manufacturingSet.openStatus = 'OPEN';
    }
    this.manufacturingSetService.setOpenStatus(manufacturingSet.ID, manufacturingSet.openStatus).subscribe(object => {
      console.log(`Changed Open Status on a ManufacturingSet : ${JSON.stringify(object)}`);
    });
  }

  /**
   * A set can only be STARTED after it has been CLOSED, so a set that is
   * **STARTED and OPEN at the same time** was reopened after work had already
   * begun.
   *
   * That is deliberate and legitimate — something did not print correctly, or
   * the PDFs have to be remade, so the set is reopened to be adjusted. But it
   * leaves the set describing itself as in-progress when it is not: the server
   * resets every ManufacturingTask under the set back to `INITIAL` as part of
   * reopening it (`ManufacturingSets.setOpenStatus`), and does not touch the
   * set's own status. The board then shows a started set whose every task says
   * it has not started.
   *
   * So the control is offered **only** in that state, and only ever moves
   * `STARTED` -> `INITIAL`. It is not a general status editor: no other
   * transition is offered here, because no other transition is a
   * reconciliation of a state the system itself produced.
   */
  canResetManufacturingSetToInitial(manufacturingSet: ManufacturingSet): boolean {
    return !!manufacturingSet
      && manufacturingSet.status === 'STARTED'
      && manufacturingSet.openStatus === 'OPEN';
  }

  resetManufacturingSetToInitial(manufacturingSet: ManufacturingSet) {
    // Re-check at the moment of action rather than trusting the render that
    // produced the button: this board is live, and another operator may have
    // closed the set (or the server may have completed it) since it was drawn.
    if ( !this.canResetManufacturingSetToInitial(manufacturingSet) ) {
      this.serverErrorToastService.reportMessage(
        LanguagePipe.get('That set is no longer started and open.'));
      return;
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: LanguagePipe.get('Set Back To Not Started'),
        body: LanguagePipe.get('This set was reopened after it was started. Its tasks have already been reset. Set it back to not started so it matches?'),
        noButton: LanguagePipe.get('Cancel'),
        yesButton: LanguagePipe.get('Set Back To Not Started'),
        returnValue: 'YES'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if ( result !== 'YES' ) {
        return;
      }
      this.manufacturingSetService.setStatus(manufacturingSet.ID, 'INITIAL').subscribe(
        () => {
          // Reflect it locally straight away. The server also sends a
          // MANUFACTURING_SET UPDATE notification, which is what makes the
          // change appear on every other operator's board; this is only so
          // THIS board does not sit on a stale value until it arrives.
          manufacturingSet.status = 'INITIAL';
          this.serverErrorToastService.reportSuccess(
            LanguagePipe.get('The set was set back to not started.'));
        },
        error => this.serverErrorToastService.reportError('setStatus', error,
          LanguagePipe.get('The set status could not be changed.'))
      );
    });
  }

  toggleManufacturingTaskBucketPeriodOpenStatus(manufacturingTaskBucketPeriod: ManufacturingTaskBucketPeriod) {
    if (manufacturingTaskBucketPeriod.status === 'OPEN') {
      manufacturingTaskBucketPeriod.status = 'CLOSED';
    } else {
      manufacturingTaskBucketPeriod.status = 'OPEN';
    }
    if (!(manufacturingTaskBucketPeriod instanceof ManufacturingTaskBucketPeriod)) {
      manufacturingTaskBucketPeriod = new ManufacturingTaskBucketPeriod(manufacturingTaskBucketPeriod);
    }
    this.manufacturingTaskBucketPeriodService.updateItem(manufacturingTaskBucketPeriod).subscribe(object => {
      console.log(`Changed manufacturingTaskBucketPeriod status : ${object}`);
    });
  }

  getManufacturingTask(manufacturingSet: ManufacturingSet, useType: string): ManufacturingTask {
    if (manufacturingSet && manufacturingSet.manufacturingTasks) {
      for (const manufacturingTask of manufacturingSet.manufacturingTasks) {
        if (manufacturingTask.useType === useType) {
          return manufacturingTask;
        }
      }
    }
    return undefined;
  }

  reload(manufacturingSet: ManufacturingSet) {
  }

  prepare(manufacturingSet: ManufacturingSet, useType: string) {
    const manufacturingTask = this.getManufacturingTask(manufacturingSet, useType);
    this.manufacturingTaskService.prepare(manufacturingTask).subscribe(changedManufacturingTask => {
      manufacturingTask.inputStatus = changedManufacturingTask.inputStatus;
      console.log(`Perpare Response for ManufacturingSet : ${manufacturingTask.ID} ${manufacturingTask.inputStatus}`);
    });
  }

  refresh() {
    this.getData(true);
  }

  // getManufacturingSets(printNodeorderItem: PrintNodeOrderItem): ManufacturingSet[] {
  //   const ret: ManufacturingSet[] = [];
  //   this.manufacturingSets.forEach(manufacturingSet => {
  //     if (!manufacturingSet.details.laminateType || manufacturingSet.details.laminateType === printNodeorderItem.book.cover.laminateType) {
  //       ret.push(manufacturingSet);
  //     }
  //     const trimSizeBreaks = '_2UP';
  //     if (!manufacturingSet.details.trimSizeBreaks || manufacturingSet.details.trimSizeBreaks === trimSizeBreaks) {
  //       ret.push(manufacturingSet);
  //     }
  //   });
  //   return ret;
  // }

  ////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////
  // AssignPrintNodeOrderItemToManufacturingSet Interface Implementation
  ////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////

  movePrintNodeOrderToManufacturingTaskBucket(printNodeOrder: PrintNodeOrder, manufacturingTaskBucketId: number, element: any) {
    element.classList.add('spinner');
    this.manufacturingSetAssignerService.movePrintNodeOrderToManufacturingTaskBucket(printNodeOrder.ID, manufacturingTaskBucketId).subscribe(p => {
      element.classList.remove('spinner');
      console.log('movePrintNodeOrderToManufacturingTaskBucket');
    });
  }

  movePrintNodeOrderToManufacturingTaskBucketPeriod(printNodeOrder: PrintNodeOrder, manufacturingTaskBucketPeriodId: number, element: any) {
    element.classList.add('spinner');
    this.manufacturingSetAssignerService.movePrintNodeOrderToManufacturingTaskBucketPeriod(printNodeOrder.ID, manufacturingTaskBucketPeriodId).subscribe(p => {
      element.classList.remove('spinner');
      console.log('movePrintNodeOrderToManufacturingTaskBucketPeriod');
    });
  }

  movePrintNodeOrderItemToManufacturingTaskBucketPeriod(printNodeOrderItem: PrintNodeOrderItem, manufacturingTaskBucketPeriodId: number, element: any) {
    element.classList.add('spinner');
    this.manufacturingSetAssignerService.movePrintNodeOrderItemToManufacturingTaskBucketPeriod(printNodeOrderItem.ID, manufacturingTaskBucketPeriodId).subscribe(p => {
      element.classList.remove('spinner');
      console.log('movePrintNodeOrderToManufacturingTaskBucketPeriod');
    });
  }

  movePrintNodeOrderItemToNextManufacturingTaskBucketPeriod(printNodeOrderItem: PrintNodeOrderItem, element: any) {
    element.classList.add('spinner');
    this.manufacturingSetAssignerService.movePrintNodeOrderItemToNextManufacturingTaskBucketPeriod(printNodeOrderItem.ID).subscribe(p => {
      element.classList.remove('spinner');
      console.log('movePrintNodeOrderToManufacturingTaskBucketPeriod');
    });
  }
  movePrintNodeOrderToNextManufacturingTaskBucketPeriod(printNodeOrder: PrintNodeOrder, element: any) {
    element.classList.add('spinner');
    this.manufacturingSetAssignerService.movePrintNodeOrderToNextManufacturingTaskBucketPeriod(printNodeOrder.ID).subscribe(p => {
      element.classList.remove('spinner');
      console.log('movePrintNodeOrderToManufacturingTaskBucketPeriod');
    });
  }

  movePrintNodeOrderItemToManufacturingSet(printNodeOrderItem: PrintNodeOrderItem, manufacturingSetId: number, element: any) {
    element.classList.add('spinner');
    printNodeOrderItem.manufacturingset_id = manufacturingSetId;
    printNodeOrderItem.manufacturingtaskbucketperiod_id = 0;
    this.manufacturingSetAssignerService.movePrintNodeOrderItemToManufacturingSet(printNodeOrderItem.ID, manufacturingSetId).subscribe(updatedPrintNodeOrder => {
      element.classList.remove('spinner');
    });
  }

  /**
   * Bulk sibling variant of
   * {@link movePrintNodeOrderItemToManufacturingSet}: move every
   * supplied `PrintNodeOrderItem` (the same-order siblings of one
   * item, all currently sharing a ManufacturingSet) into an
   * existing target `ManufacturingSet`. Optimistically flips each
   * PNOI's `manufacturingset_id` locally so the picker rerenders
   * immediately, then relies on the notification stream to fold in
   * the authoritative server state. Server contract:
   * `docs/contracts/outbox/2026-07-21-manufacturing-set-move-siblings-existing.md`.
   */
  movePrintNodeOrderItemsToManufacturingSet(printNodeOrderItems: PrintNodeOrderItem[], manufacturingSetId: number, element: any) {
    if (!printNodeOrderItems || printNodeOrderItems.length === 0) { return; }
    element.classList.add('spinner');
    const ids: number[] = [];
    for (const pnoi of printNodeOrderItems) {
      pnoi.manufacturingset_id = manufacturingSetId;
      pnoi.manufacturingtaskbucketperiod_id = 0;
      ids.push(pnoi.ID);
    }
    this.manufacturingSetAssignerService.movePrintNodeOrderItemsToManufacturingSet(ids, manufacturingSetId).subscribe(_ => {
      element.classList.remove('spinner');
      console.log('movePrintNodeOrderItemsToManufacturingSet count=' + ids.length);
    });
  }

  addManufacturingSetAndAssignPrintNodeOrderItemToManufacturingTaskBucket(printNodeOrderItem: PrintNodeOrderItem, manufacturingTaskBucketId: number, element: any) {
    element.classList.add('spinner');
    this.manufacturingSetAssignerService.addManufacturingSetAndAssignPrintNodeOrderItemToManufacturingTaskBucket(printNodeOrderItem.ID, manufacturingTaskBucketId).subscribe(p => {
      element.classList.remove('spinner');
      console.log('addManufacturingSetAndAssignPrintNodeOrderItemToManufacturingTaskBucket');
    });
  }

  addManufacturingSetAndAssignPrintNodeOrderItemToManufacturingSet(printNodeOrderItem: PrintNodeOrderItem, manufacturingTaskBucketPeriodId: number, element: any) {
    element.classList.add('spinner');
    this.manufacturingSetAssignerService.addManufacturingSetAndAssignPrintNodeOrderItemToManufacturingSet(printNodeOrderItem.ID, manufacturingTaskBucketPeriodId).subscribe(p => {
      element.classList.remove('spinner');
      console.log('addManufacturingSetAndAssignPrintNodeOrderItemToManufacturingSet');
    });
  }

  /**
   * Bulk sibling variant of
   * {@link addManufacturingSetAndAssignPrintNodeOrderItemToManufacturingSet}:
   * move every supplied `PrintNodeOrderItem` (the same-order
   * siblings of one item, all currently sharing a ManufacturingSet)
   * into a freshly-created ManufacturingSet in
   * `manufacturingTaskBucketPeriodId`. Server contract:
   * `docs/contracts/outbox/2026-07-21-manufacturing-set-move-siblings.md`.
   */
  addManufacturingSetAndAssignPrintNodeOrderItemsToManufacturingSet(printNodeOrderItems: PrintNodeOrderItem[], manufacturingTaskBucketPeriodId: number, element: any) {
    if (!printNodeOrderItems || printNodeOrderItems.length === 0) { return; }
    element.classList.add('spinner');
    const ids = printNodeOrderItems.map(p => p.ID);
    this.manufacturingSetAssignerService.addManufacturingSetAndAssignPrintNodeOrderItemsToManufacturingSet(ids, manufacturingTaskBucketPeriodId).subscribe(_ => {
      element.classList.remove('spinner');
      console.log('addManufacturingSetAndAssignPrintNodeOrderItemsToManufacturingSet count=' + ids.length);
    });
  }

  /**
   * The facility is assigned optimistically so the tile moves immediately,
   * but the server can refuse the move (items in a CLOSED ManufacturingSet)
   * and signals that by returning the order *unchanged* rather than by
   * erroring. So the response is authoritative: if it disagrees with what we
   * asked for, we take the server's value back.
   *
   * The previous implementation reassigned the local `printNodeOrder`
   * parameter, which is a no-op for the caller — the optimistic mutation was
   * the only thing that ever reached the UI, so a refused move looked like it
   * had succeeded. See
   * `docs/contracts/inbox/_processed/2026-09-21b-manufacturingsetassigner-closed-set-guard-and-route-errors.md` §2.
   */
  changeFacility(printNodeOrder: PrintNodeOrder, facilityId: number, element: any) {
    element.classList.add('spinner');
    const previousFacilityId = printNodeOrder.printnode_ID;
    printNodeOrder.printnode_ID = facilityId;
    this.manufacturingSetAssignerService.changeFacility(printNodeOrder).subscribe(changedPrintNodeOrder => {
      element.classList.remove('spinner');
      if ( !changedPrintNodeOrder ) {
        // Request failed outright - undo the optimistic move.
        printNodeOrder.printnode_ID = previousFacilityId;
        return;
      }
      if ( changedPrintNodeOrder.printnode_ID !== facilityId ) {
        console.log(`changeFacility: server refused the move of printNodeOrder ${printNodeOrder.ID} to facility ${facilityId}; it remains on ${changedPrintNodeOrder.printnode_ID}. Items are likely in a CLOSED ManufacturingSet - split the order or reopen the set.`);
      }
      printNodeOrder.printnode_ID = changedPrintNodeOrder.printnode_ID;
    });
  }

  changeFacilityAndInventoryType(printNodeOrder: PrintNodeOrder, facilityId: number, inventoryType: string, element: any) {
    element.classList.add('spinner');
    const previousFacilityId = printNodeOrder.printnode_ID;
    const previousInventoryType = printNodeOrder.inventoryType;
    printNodeOrder.printnode_ID = facilityId;
    printNodeOrder.inventoryType = inventoryType;
    this.manufacturingSetAssignerService.changeFacilityAndInventoryType(printNodeOrder).subscribe(changedPrintNodeOrder => {
      element.classList.remove('spinner');
      if ( !changedPrintNodeOrder ) {
        printNodeOrder.printnode_ID = previousFacilityId;
        printNodeOrder.inventoryType = previousInventoryType;
        return;
      }
      if ( changedPrintNodeOrder.printnode_ID !== facilityId || changedPrintNodeOrder.inventoryType !== inventoryType ) {
        console.log(`changeFacilityAndInventoryType: server refused the move of printNodeOrder ${printNodeOrder.ID} to facility ${facilityId}/${inventoryType}; it remains on ${changedPrintNodeOrder.printnode_ID}/${changedPrintNodeOrder.inventoryType}. Items are likely in a CLOSED ManufacturingSet - split the order or reopen the set.`);
      }
      printNodeOrder.printnode_ID = changedPrintNodeOrder.printnode_ID;
      printNodeOrder.inventoryType = changedPrintNodeOrder.inventoryType;
    });
  }

  // changeItemInventoryType(printNodeOrderItem: PrintNodeOrderItem, inventoryType: string, element: any) {
  //   element.classList.add('spinner');
  //   printNodeOrderItem.inventoryType = inventoryType;
  //   this.manufacturingSetAssignerService.changeItemInventoryType(printNodeOrderItem).subscribe(changedPrintNodeOrder => {
  //     element.classList.remove('spinner');
  //     printNodeOrderItem = changedPrintNodeOrder;
  //   });
  // }

  selectPrintNodeOrder(printNodeOrderId: number) {
    if (this.selectedPrintNodeOrderId === printNodeOrderId) {
      this.selectedPrintNodeOrderId = 0;
    } else {
      this.selectedPrintNodeOrderId = printNodeOrderId;
    }
  }

  reloadAll() {
    // Heal ManufactringTaskBucks not having ManufacturingTaskBucketPeriods
    for ( const manufacturingTaskBucketPeriod of this.manufacturingTaskBucketPeriodService.objects ) {
      manufacturingTaskBucketPeriod.manufacturingTaskBucket = this.manufacturingTaskBucketService.objectsById['' + manufacturingTaskBucketPeriod.manufacturingTaskBucket_id];
      if ( manufacturingTaskBucketPeriod.manufacturingTaskBucket ) {
        let contains = false;
        for ( const mtbp of manufacturingTaskBucketPeriod.manufacturingTaskBucket.manufacturingTaskBucketPeriods) {
          if (mtbp.ID === manufacturingTaskBucketPeriod.ID) {
            contains = true;
          }
        }
        if ( !contains ) {
          manufacturingTaskBucketPeriod.manufacturingTaskBucket.manufacturingTaskBucketPeriods.push(manufacturingTaskBucketPeriod);
        }
      }
    }
    this.computeActionableManufacturingTaskBuckets();
  }

  openReplenishmentSelector(manufacturingSet: any, facilityInventoryProducts: any[]) {
    const setId = manufacturingSet.ID;
    if (!setId) { return; }
    const dialogRef = this.dialog.open(ReplenishmentSelectorComponent, {
      width: '700px',
      data: {
        manufacturingSet,
        facilityInventoryProducts
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.facilityInventoryProducts && result.quantities) {
        this.isProcessingReplenishment[setId] = true;
        this.createReplenishmentOrderForSet(result.facilityInventoryProducts, result.quantities, manufacturingSet);
      }
    });
  }

  createReplenishmentOrderForSet(facilityInventoryProducts: any[], quantities: number[], manufacturingSet: any) {
    const setId: number = manufacturingSet.ID;

    // These guards used to return without clearing the spinner flag the
    // caller had already set, leaving the set's replenishment button
    // disabled until the page was reloaded.
    if ( facilityInventoryProducts.length === 0 || facilityInventoryProducts.length !== quantities.length ) {
      this.isProcessingReplenishment[setId] = false;
      return;
    }

    const printNodeId: number = facilityInventoryProducts[0].printnode_ID;

    // Single-step replenishment-into-a-set.
    //
    // This used to be a two-step process: create the replenishment
    // Order/OrderDeliverTo, then scan printNodeOrderService.objects for
    // the PrintNodeOrder the server had created from it and PUT
    // manufacturingset_ID onto each of its PrintNodeOrderItems. That
    // never worked, and could not have: the PrintNodeOrder and its
    // items are created asynchronously by the server AFTER the
    // OrderDeliverTo POST returns, so the local cache is always empty
    // of them at the moment the scan runs. The loop simply found
    // nothing and fell through silently - the replenishment order was
    // created but was never assigned to the set.
    //
    // Instead the desired facility and manufacturing set now ride
    // along on the OrderDeliverTo as routing hints
    // (requestedPrintNode_ID / requestedManufacturingSet_ID) and the
    // server applies them while it is creating the rows, inside its
    // own transaction. See docs/contracts/shared/ReplenishmentOrder.md.
    let outstanding = facilityInventoryProducts.length;
    let failures = 0;
    const done = () => {
      outstanding--;
      if ( outstanding <= 0 ) {
        this.isProcessingReplenishment[setId] = false;
        if ( failures === 0 ) {
          this.serverErrorToastService.reportSuccess(
            LanguagePipe.get('Replenishment order placed.'));
        }
      }
    };

    this.facilityService.getItem(Number(printNodeId)).subscribe(facility => {
      if ( !facility ) {
        this.isProcessingReplenishment[setId] = false;
        console.error(`Could not load Facility ${printNodeId} - replenishment for ManufacturingSet ${setId} abandoned`);
        this.serverErrorToastService.reportMessage(
          LanguagePipe.get('The replenishment order could not be placed.'));
        return;
      }
      for ( let i = 0; i < facilityInventoryProducts.length; i++ ) {
        const facilityInventoryProduct = facilityInventoryProducts[i];
        const quantity = quantities[i];
        const orderx = new Order(undefined);
        orderx.org_ID = facilityInventoryProduct.product.org_ID;
        const customerOrderIdDate = new Date();
        orderx.customerorderid = 'Replenishment-' + (customerOrderIdDate.getMonth() + 1) + '.' + (customerOrderIdDate.getDate() + 1) + '.' + customerOrderIdDate.getFullYear() + '.' + Math.floor(Math.random() * 1000);
        orderx.inventoryType = 'REPLENISH_INVENTORY';
        orderx.replenishmentFacility_ID = facilityInventoryProduct.printnode_ID;
        this.orderService.addOrder(orderx).subscribe(order => {
          if ( !order || !order.ID ) {
            console.error(`Could not create the replenishment Order for FacilityInventoryProduct ${facilityInventoryProduct.ID}`);
            failures++;
            this.serverErrorToastService.reportMessage(
              LanguagePipe.get('The replenishment order could not be placed.'));
            done();
            return;
          }
          const orderDeliverTo = new OrderDeliverTo(undefined);
          orderDeliverTo.inventoryType = order.inventoryType;
          orderDeliverTo.order_ID = order.ID;

          orderDeliverTo.title = '';
          orderDeliverTo.firstname = facilityInventoryProduct.title;
          orderDeliverTo.lastname = `Fill in for Set ` + manufacturingSet.ID;
          orderDeliverTo.address1 = facility.toAddress1;
          orderDeliverTo.address2 = facility.toAddress2;
          orderDeliverTo.address3 = facilityInventoryProduct.location + ' ' + facilityInventoryProduct.shelf;
          orderDeliverTo.city = facility.toCity;
          orderDeliverTo.state = facility.toState;
          orderDeliverTo.postalcode = facility.toPostalCode;
          orderDeliverTo.country = facility.toCountry;
          orderDeliverTo.carrier = 'INPLANT';
          orderDeliverTo.servicelevel = 'PICKUP';
          orderDeliverTo.requestedPrintNodeName = '' + facility.name;
          orderDeliverTo.replenishmentFacility_ID = facilityInventoryProduct.printnode_ID;
          // The two routing hints that make this a one-step operation.
          orderDeliverTo.requestedPrintNode_ID = facilityInventoryProduct.printnode_ID;
          orderDeliverTo.requestedManufacturingSet_ID = manufacturingSet.ID;
          const orderItem = new OrderItem( undefined );
          orderItem.product_ID = facilityInventoryProduct.product_ID;
          orderItem.quantity = quantity;
          orderDeliverTo.orderItems.push(orderItem);
          // PF-13. This used to `console.error` on failure and call done(),
          // so a REJECTED replenishment was indistinguishable from a placed
          // one: the spinner stopped and nothing else changed. The operator
          // found out when the stock never arrived.
          //
          // The set-state rejections are the ones that actually happen here.
          // `isPrintNodeOrderItemCompatableWithManufacturingSet` only checks
          // `openStatus === 'CLOSED'` against the LOCAL cache, so a set that
          // was closed (or completed, or errored) by another operator since
          // this screen loaded still offers the button. The server is the
          // only authority, and it answers with the stable code
          // `manufacturing set closed` -- which is branched on here to say
          // something specific, rather than showing the raw code.
          this.orderDeliverToService.addOrderDeliverTo(orderDeliverTo).subscribe(
            createdOrderDeliverTo => {
              console.log(`Created replenishment OrderDeliverTo ${createdOrderDeliverTo.ID} for ManufacturingSet ${manufacturingSet.ID} at facility ${facilityInventoryProduct.printnode_ID}`);
              done();
            },
            error => {
              failures++;
              if ( serverErrorCode(error) === 'manufacturing set closed' ) {
                // Refresh so the board stops offering a set the server has
                // already closed.
                this.manufacturingSetService.getItem(Number(manufacturingSet.ID)).subscribe();
              }
              this.serverErrorToastService.reportError('addOrderDeliverTo (replenishment)', error,
                LanguagePipe.get('The replenishment order could not be placed.'));
              done();
            }
          );
        });
      }
    });
  }
}
